<template>
  <div class="p-1.5 md:p-3 bg-gray-50 dark:bg-gray-900 min-h-screen font-sans overflow-x-hidden">
    <!-- Cabecera de la Orden y Rastreo de Personal (Cuidarse la Espalda) -->
    <div v-if="orden" class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden mb-4">
      <div class="p-4 bg-gradient-to-r from-green-600 to-emerald-700">
        <div class="flex flex-wrap justify-between items-center gap-3">
          <div class="flex items-center gap-3">
             <button @click="$router.push('/recepcion-equipo-list')" class="p-2 bg-white/20 hover:bg-white/30 rounded-xl text-white transition-all">
                <Icon icon="mdi:arrow-left" class="text-xl" />
             </button>
             <div>
                <h1 class="text-xl font-black text-white flex items-center gap-2 leading-none">
                  ORDEN #{{ orden?.numeroOrden }}
                </h1>
                <p class="text-green-100 text-[10px] font-bold uppercase tracking-widest mt-1">Gestión de Servicio Técnico</p>
             </div>
          </div>
          
          <div class="px-3 py-1.5 bg-white/20 backdrop-blur-md border border-white/30 rounded-xl text-white text-[10px] font-black uppercase">
             {{ orden?.nombreEstado }}
          </div>
        </div>

        <!-- RASTREO INDEPENDIENTE DE PERSONAL -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-2 mt-4">
          <div class="bg-white/10 backdrop-blur-sm rounded-xl p-2 border border-white/10">
            <div class="flex items-center gap-2 mb-0.5">
              <Icon icon="mdi:account-arrow-right" class="text-green-200 text-xs" />
              <span class="text-[8px] font-black text-green-200 uppercase">1. Recibido por:</span>
            </div>
            <p class="text-white text-[11px] font-bold truncate">{{ orden?.nombreTecnicoRecepcion || orden?.NombreTecnicoRecepcion || orden?.nombreUsuario || orden?.NombreUsuario || 'Cajero/Recepción' }}</p>
          </div>

          <div class="bg-white/10 backdrop-blur-sm rounded-xl p-2 border border-white/10">
            <div class="flex items-center gap-2 mb-0.5">
              <Icon icon="mdi:hammer-wrench" class="text-yellow-200 text-xs" />
              <span class="text-[8px] font-black text-yellow-200 uppercase">2. Reparado por:</span>
            </div>
            <p class="text-white text-[11px] font-bold truncate">{{ orden?.nombreTecnicoReparador || orden?.NombreTecnicoReparador || 'Pendiente' }}</p>
          </div>

          <div class="bg-white/10 backdrop-blur-sm rounded-xl p-2 border border-white/10">
            <div class="flex items-center gap-2 mb-0.5">
              <Icon icon="mdi:truck-delivery" class="text-blue-200 text-xs" />
              <span class="text-[8px] font-black text-blue-200 uppercase">3. Entregado por:</span>
            </div>
            <p class="text-white text-[11px] font-bold truncate">{{ orden?.nombreTecnicoEntrega || orden?.NombreTecnicoEntrega || 'No Entregado' }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Carga Global -->
    <div v-if="loadingGlobal" class="flex flex-col items-center justify-center py-32">
      <Icon icon="mdi:loading" class="animate-spin text-blue-500 text-6xl shadow-inner rounded-full mb-4" />
      <p class="text-gray-500 font-bold tracking-widest text-sm animate-pulse">Sincronizando Sistema...</p>
    </div>

    <!-- No se encontró -->
    <div v-else-if="!orden" class="bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-gray-100 dark:border-gray-700 p-12 text-center m-4">
      <Icon icon="mdi:file-search-outline" class="text-[100px] text-gray-300 dark:text-gray-600 mx-auto mb-4" />
      <h2 class="text-2xl font-bold text-gray-600 dark:text-gray-300 mb-2">Orden no localizada</h2>
      <p class="text-gray-400">Verifique el número y vuelva a intentarlo o regrese al listado.</p>
    </div>

    <!-- Grid Principal -->
    <div v-else class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      
      <!-- COLUMNA IZQUIERDA: RESUMEN -->
      <div class="space-y-3">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow border border-gray-100 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 px-3 py-1.5 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-2 shadow-sm">
                <Icon icon="mdi:card-account-details" class="text-blue-600 dark:text-blue-400 text-lg" />
              </div>
              Datos del Cliente
            </h2>
          </div>
          <div class="p-3">
            <div class="flex items-center gap-3 border-b border-gray-100 dark:border-gray-700 pb-3 mb-3">
              <div class="w-10 h-10 bg-blue-50 dark:bg-gray-700 rounded-xl flex items-center justify-center font-black text-xl text-blue-500">
                {{ orden.nombreCliente?.charAt(0) || 'C' }}
              </div>
              <div class="flex-1 overflow-hidden">
                <p class="text-[9px] text-gray-400 font-bold uppercase tracking-wider mb-0.5 leading-none">Cliente</p>
                <p class="font-bold text-lg text-gray-800 dark:text-white leading-none truncate">{{ orden.nombreCliente }}</p>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-2 mt-2">
              <div class="bg-gray-50/50 dark:bg-gray-900/50 p-2.5 rounded-xl border border-gray-100 dark:border-gray-800">
                <p class="text-xs text-gray-500 font-black uppercase tracking-wider leading-none mb-1.5 flex items-center gap-1"><Icon icon="mdi:identifier" /> ID / DOCUMENTO</p>
                <p class="text-sm text-gray-900 dark:text-white font-black font-mono">{{ orden.documentoCliente || 'S/D' }}</p>
              </div>
              <div class="bg-gray-50/50 dark:bg-gray-900/50 p-2.5 rounded-xl border border-gray-100 dark:border-gray-800">
                <p class="text-xs text-gray-500 font-black uppercase tracking-wider leading-none mb-1.5 flex items-center gap-1"><Icon icon="mdi:phone" /> TELÉFONO</p>
                <p class="text-sm text-gray-900 dark:text-white font-black">{{ clienteFull?.telefono || 'N/A' }}</p>
              </div>
            </div>
            <div class="mt-2 space-y-2">
              <div class="bg-gray-50/50 dark:bg-gray-900/50 p-2.5 rounded-xl border border-gray-100 dark:border-gray-800">
                <p class="text-xs text-gray-500 font-black uppercase tracking-wider leading-none mb-1.5 flex items-center gap-1"><Icon icon="mdi:email" /> CORREO ELECTRÓNICO</p>
                <p class="text-sm text-gray-900 dark:text-white font-black truncate">{{ clienteFull?.email || 'No registrado' }}</p>
              </div>
              <div class="bg-gray-50/50 dark:bg-gray-900/50 p-2.5 rounded-xl border border-gray-100 dark:border-gray-800">
                <p class="text-xs text-gray-500 font-black uppercase tracking-wider leading-none mb-1.5 flex items-center gap-1"><Icon icon="mdi:map-marker" /> DIRECCIÓN DE DOMICILIO</p>
                <p class="text-sm text-gray-800 dark:text-gray-200 font-bold leading-snug">{{ clienteFull?.direccion || 'Sin dirección registrada' }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow border border-gray-100 dark:border-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-orange-50 to-amber-50 dark:from-gray-800 dark:to-gray-800 px-3 py-1.5 border-b border-gray-100 dark:border-gray-700">
            <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 bg-orange-100 dark:bg-orange-900/30 rounded-lg mr-2 shadow-sm">
                <Icon icon="mdi:cellphone-link" class="text-orange-600 dark:text-orange-400 text-lg" />
              </div>
              Evaluación Técnica
            </h2>
          </div>
          <div class="p-3 space-y-3">
            <div>
              <p class="text-[10px] font-black text-gray-500 uppercase tracking-wider mb-1 px-1">Equipo / Producto</p>
              <div class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-900/50 rounded-xl border border-gray-100 dark:border-gray-700/50 font-bold text-gray-800 dark:text-gray-200 text-sm">
                {{ orden.descripcion || 'Sin descripción' }}
              </div>
            </div>
            <div>
               <p class="text-[10px] font-black text-red-500 uppercase tracking-wider mb-1 px-1">Problema Reportado</p>
              <div class="w-full px-3 py-2 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-100 dark:border-red-800/30 font-bold text-red-700 dark:text-red-300 text-xs">
                {{ orden.problema || 'N/A' }}
              </div>
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div class="p-2 bg-blue-50/50 dark:bg-blue-900/10 rounded-xl border border-blue-100 dark:border-blue-800/30">
                <p class="text-[9px] font-black text-blue-500 uppercase tracking-wider mb-1">Diagnóstico</p>
                <span class="font-bold text-blue-700 dark:text-blue-400 text-xs truncate block">{{ orden.tipoDiagnostico || 'GRATIS' }} (${{ orden.montoDiagnostico || 0 }})</span>
              </div>
              <div class="p-2 bg-gray-50/50 dark:bg-gray-900/50 rounded-xl border border-gray-100 dark:border-gray-800">
                 <p class="text-[9px] font-black text-gray-500 uppercase tracking-wider mb-1">Accesorios</p>
                <div class="font-bold text-gray-600 dark:text-gray-400 text-xs truncate">{{ orden.accesorios || orden.clavePatron || 'Ninguno' }}</div>
              </div>
            </div>
            </div>
          </div>
        </div>
        
      <div class="space-y-3">
        <!-- FASE 1: SOLO LECTURA -->
        <div v-if="pasoActual === 1" class="space-y-3 animate-fadeIn">
          <div class="bg-white dark:bg-gray-800 rounded-2xl shadow border border-gray-100 dark:border-gray-700 overflow-hidden">
            <div class="bg-gradient-to-r from-indigo-50 to-violet-50 dark:from-gray-800 dark:to-gray-800 px-3 py-1.5 border-b border-gray-100 dark:border-gray-700">
              <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
                <div class="p-1.5 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg mr-2"><Icon icon="mdi:clipboard-text-search" class="text-indigo-600 dark:text-indigo-400 text-lg" /></div>
                Bitácora Técnica
              </h2>
            </div>
            <div class="p-3 space-y-2">
              <div>
                <p class="text-[9px] font-black text-indigo-500 uppercase tracking-wider mb-1">Diagnóstico</p>
                <div class="px-3 py-2 bg-indigo-50 dark:bg-indigo-900/20 rounded-xl border border-indigo-100 dark:border-indigo-800/40 text-xs font-medium text-indigo-800 dark:text-indigo-300">
                  {{ orden.problemaEncontrado || orden.actividadesRealizadas?.split('\n')[0] || 'Sin diagnóstico registrado' }}
                </div>
              </div>
              <div>
                <p class="text-[9px] font-black text-green-600 uppercase tracking-wider mb-1">Solución / Actividades</p>
                <div class="px-3 py-2 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-100 dark:border-green-800/40 text-xs font-medium text-green-800 dark:text-green-300 whitespace-pre-wrap max-h-32 overflow-y-auto">
                  {{ orden.actividadesRealizadas || 'Sin solución registrada' }}
                </div>
              </div>
            </div>
          </div>

          <div class="bg-white dark:bg-gray-800 rounded-2xl shadow border border-gray-100 dark:border-gray-700 overflow-hidden">
            <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 px-3 py-1.5 border-b border-gray-100 dark:border-gray-700">
              <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
                <div class="p-1.5 bg-green-100 dark:bg-green-900/30 rounded-lg mr-2"><Icon icon="mdi:cash-multiple" class="text-green-600 dark:text-green-400 text-lg" /></div>
                Servicios y Productos Cobrados
              </h2>
            </div>
            <div class="p-3">
              <div v-if="itemsAgregados.length === 0 && itemsRepuestosManuales.length === 0" class="py-6 text-center">
                <Icon icon="mdi:package-variant-remove" class="text-4xl text-gray-300 mx-auto mb-2" />
                <p class="text-xs text-gray-400">No hay servicios ni productos registrados</p>
              </div>

              <div v-if="itemsAgregados.length > 0" class="space-y-1.5 mb-3">
                <p class="text-[9px] font-black text-gray-400 uppercase tracking-wider mb-1">Servicios / Productos</p>
                <div v-for="it in itemsAgregados" :key="it.uuid" class="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-900/50 rounded-xl border border-gray-100 dark:border-gray-700">
                  <div class="flex items-center gap-2 flex-1 min-w-0">
                    <div :class="it.tipo === 'servicio' ? 'bg-green-100 dark:bg-green-900/30 text-green-600' : 'bg-blue-100 dark:bg-blue-900/30 text-blue-600'" class="p-1.5 rounded-lg shrink-0">
                      <Icon :icon="it.tipo === 'servicio' ? 'mdi:wrench' : 'mdi:package-variant'" class="text-xs" />
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center gap-2 flex-wrap">
                        <p class="text-[10px] font-bold text-gray-800 dark:text-white truncate uppercase">{{ it.nombre }}</p>
                        <span v-if="it.cantidad && it.cantidad > 1" class="text-[8px] font-black bg-gray-200 dark:bg-gray-700 px-1.5 py-0.5 rounded-full">x{{ it.cantidad }}</span>
                        <span v-if="it.garantia && it.garantia > 0" class="text-[8px] font-black bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                          🛡️ {{ formatearGarantia(it.garantia) }}
                        </span>
                      </div>
                      <p class="text-[8px] text-gray-400 font-black uppercase tracking-widest">{{ it.tipo }} {{ it.cantidad && it.cantidad > 1 ? `( $${it.precio_unitario} c/u )` : '' }}</p>
                    </div>
                  </div>
                  <span class="text-xs font-black text-green-600 dark:text-green-400 ml-2">${{ (it.precio_total || it.precio || 0).toFixed(2) }}</span>
                </div>
              </div>

              <div v-if="itemsRepuestosManuales.length > 0" class="space-y-1.5 mb-3">
                <p class="text-[9px] font-black text-orange-500 uppercase tracking-wider mb-1">Repuestos</p>
                <div v-for="rep in itemsRepuestosManuales" :key="rep.uuid" class="flex items-center justify-between p-2 bg-orange-50/50 dark:bg-orange-900/10 rounded-xl border border-orange-100 dark:border-orange-800/40">
                  <div class="flex items-center gap-2 flex-1 min-w-0">
                    <div class="p-1.5 bg-orange-100 dark:bg-orange-900/30 rounded-lg shrink-0">
                      <Icon icon="mdi:tools" class="text-orange-600 text-xs" />
                    </div>
                    <p class="text-[10px] font-bold text-gray-800 dark:text-white truncate uppercase">{{ rep.nombre }}</p>
                  </div>
                  <span class="text-xs font-black text-orange-600 dark:text-orange-400 ml-2">${{ parseFloat(rep.precio || 0).toFixed(2) }}</span>
                </div>
              </div>

              <div class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700 space-y-1.5">
                <div class="flex justify-between items-center bg-green-50 dark:bg-green-900/20 px-3 py-2 rounded-xl border border-green-100 dark:border-green-800/40">
                  <span class="text-[10px] font-black text-green-700 dark:text-green-400 uppercase tracking-wider">TOTAL GENERAL:</span>
                  <span class="text-lg font-black text-green-600 dark:text-green-400">${{ ((orden?.precioTotalUsd || 0) + totalFase2).toFixed(2) }}</span>
                </div>
              </div>
            </div>
          </div>

          <button @click="$router.push('/recepcion-equipo-list')" class="w-full px-4 py-2.5 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-[10px] font-black rounded-xl hover:bg-gray-200 transition-all shadow-sm flex items-center justify-center gap-2 uppercase tracking-widest">
            <Icon icon="mdi:arrow-left" /> Volver al Listado
          </button>
        </div>

        <!-- FASE 2: DIAGNÓSTICO Y REPARACIÓN -->
        <div v-if="pasoActual === 2" class="bg-white dark:bg-gray-800 rounded-2xl shadow border border-gray-100 dark:border-gray-700 overflow-hidden animate-fadeIn">
          <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 px-3 py-1.5 border-b border-gray-100 dark:border-gray-700 flex justify-between items-center">
            <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 bg-green-100 dark:bg-green-900/30 rounded-lg mr-2 shadow-sm">
                <Icon icon="mdi:clipboard-check-outline" class="text-green-600 dark:text-green-400 text-lg" />
              </div>
              Actualización Técnica
            </h2>
            <div class="text-[9px] font-black px-2 py-0.5 bg-white dark:bg-gray-700 text-green-600 dark:text-green-400 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 tracking-widest uppercase">Fase 2</div>
          </div>
          <div class="p-3 space-y-3">
            <div v-if="esGarantia" class="mb-3 p-3 bg-rose-50 dark:bg-rose-900/30 border-2 border-rose-200 dark:border-rose-800 rounded-2xl flex items-center justify-center gap-3 animate-fadeIn">
               <div class="p-2 bg-rose-500 text-white rounded-full shadow-lg">
                  <Icon icon="mdi:shield-check" class="text-xl" />
               </div>
               <div>
                  <p class="text-xs font-black text-rose-700 dark:text-rose-300 uppercase leading-none">EQUIPO EN GARANTÍA</p>
                  <p class="text-[9px] font-bold text-rose-500 opacity-70">Estado Final de Soporte</p>
               </div>
            </div>

            <div v-else-if="esEntregado" class="mb-3 p-3 bg-indigo-50 dark:bg-indigo-900/30 border-2 border-indigo-200 dark:border-indigo-800 rounded-2xl flex items-center justify-center gap-3 animate-fadeIn">
               <div class="p-2 bg-indigo-500 text-white rounded-full shadow-lg">
                  <Icon icon="mdi:truck-delivery" class="text-xl" />
               </div>
               <div>
                  <p class="text-xs font-black text-indigo-700 dark:text-indigo-300 uppercase leading-none">EQUIPO ENTREGADO</p>
                  <p class="text-[9px] font-bold text-indigo-500 opacity-70">Puede pasar a Garantía si es necesario</p>
               </div>
            </div>

            <div class="bg-indigo-50/50 dark:bg-indigo-900/10 p-3 rounded-xl border border-indigo-100 dark:border-indigo-800/40">
              <label class="block text-[10px] font-black text-indigo-700 dark:text-indigo-300 uppercase tracking-wider mb-2">Nuevo Estado 🎯</label>
              <select v-model.number="form.idEstadoRecepcion" :disabled="esEstadoInalterable" @change="alCambiarEstadoSelect" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 focus:border-indigo-500 rounded-lg bg-white dark:bg-gray-800 text-sm font-bold shadow-sm outline-none transition-all" :class="{'opacity-50 cursor-not-allowed': esEstadoInalterable}">
                <option value="0">--- SELECCIONE UN NUEVO ESTADO ---</option>
                <option v-for="est in estadosDisponibles" :key="est.idEstadoRecepcion" :value="est.idEstadoRecepcion">{{ est.nombre?.toUpperCase() }}</option>
              </select>
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div class="bg-gray-50/50 p-2 rounded-xl border border-gray-100 dark:bg-gray-900/30 dark:border-gray-800">
                <label class="block text-[9px] font-black text-gray-500 uppercase tracking-wider mb-1 flex items-center gap-1">
                  <Icon icon="mdi:account-cog" class="text-indigo-500" /> Responsable de Reparación <span v-if="!esEstadoSinCargos" class="text-red-500">*</span>
                </label>
                   <div class="mt-1 flex items-center justify-between bg-green-50 dark:bg-green-900/20 p-1 px-2 rounded-lg border border-green-100 dark:border-green-800/40">
                      <span class="text-[9px] font-black text-green-700 dark:text-green-400 truncate uppercase">
                        ✓ {{ tecnicos.find(x => x.idTecnico === form.idTecnico)?.nombre || 'Técnico' }} {{ tecnicos.find(x => x.idTecnico === form.idTecnico)?.apellido || '' }}
                      </span>
                   </div>
                </div>
              <div class="bg-indigo-50/50 p-2 rounded-xl border border-indigo-100 dark:bg-gray-900/30 dark:border-indigo-800/40">
                <label class="block text-[9px] font-black text-indigo-700 dark:text-indigo-300 uppercase tracking-wider mb-1">Fecha de Reparación</label>
                <input v-model="form.fechaHora" type="datetime-local" class="w-full bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 focus:border-indigo-500 rounded-lg text-xs font-bold outline-none transition-all" />
              </div>
            </div>
            <div>
              <label class="block text-[10px] font-black text-gray-600 dark:text-gray-400 uppercase mb-1">Diagnóstico <span v-if="!esEstadoSinCargos" class="text-red-500">*</span></label>
              <textarea v-model="form.problemaEncontrado" :readonly="esEntregado" rows="2" placeholder="Fallo detectado..." class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 focus:border-teal-500 focus:ring-1 focus:ring-teal-500 bg-white dark:bg-gray-900 rounded-xl text-xs resize-none outline-none font-medium transition-all shadow-sm" :class="{'opacity-75 bg-gray-50': esEntregado}"></textarea>
            </div>
            <div>
              <label class="block text-[10px] font-black text-gray-600 dark:text-gray-400 uppercase mb-1">Observación del técnico <span v-if="!esEstadoSinCargos" class="text-red-500">*</span></label>
              <textarea v-model="form.actividadesRealizadas" :readonly="esEntregado" rows="5" placeholder="Observaciones técnicas... (Describa detalladamente todo lo que se hizo)" class="w-full px-3 py-2 border-2 border-gray-300 dark:border-gray-600 focus:border-teal-500 focus:ring-1 focus:ring-teal-500 bg-white dark:bg-gray-900 rounded-xl text-xs resize-none outline-none font-medium transition-all shadow-sm" :class="{'opacity-75 bg-gray-50': esEntregado}"></textarea>
            </div>
            <div class="bg-gray-50 dark:bg-gray-900/40 p-3 rounded-xl border border-gray-200 dark:border-gray-700 shadow-inner">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-black text-gray-800 dark:text-white flex items-center text-[9px] uppercase tracking-wider leading-none"><Icon icon="mdi:cash-multiple" class="mr-2 text-green-600 text-lg" /> Cobros Adicionales</h3>
                <button v-if="!esEntregado" @click="abrirModalConfiguracionItem('servicio')" :disabled="esImposibleReparar" :class="esImposibleReparar ? 'opacity-50 cursor-not-allowed' : ''" class="text-[8px] font-black px-2 py-1 bg-green-500 text-white rounded-lg shadow-sm hover:scale-105 transition-all uppercase tracking-widest flex items-center gap-1">
                  <Icon icon="mdi:plus-circle" /> AGREGAR SERVICIO
                </button>
                <button v-if="!esEntregado" @click="abrirModalConfiguracionItem('producto')" :disabled="esImposibleReparar" :class="esImposibleReparar ? 'opacity-50 cursor-not-allowed' : ''" class="text-[8px] font-black px-2 py-1 bg-blue-500 text-white rounded-lg shadow-sm hover:scale-105 transition-all uppercase tracking-widest flex items-center gap-1">
                  <Icon icon="mdi:plus-circle" /> AGREGAR PRODUCTO
                </button>
              </div>

              <!-- Listado de Carrito -->
              <div v-if="itemsAgregados.length > 0" class="space-y-1.5 mb-3">
                <div v-for="it in itemsAgregados" :key="it.uuid" class="flex items-center justify-between p-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 shadow-sm">
                  <div class="flex-1 overflow-hidden mr-2">
                    <div class="flex items-center gap-2 flex-wrap">
                      <input v-model="it.nombre" :readonly="esEntregado" class="flex-1 text-[9px] font-bold text-gray-800 dark:text-white uppercase bg-transparent border-b border-transparent focus:border-teal-500 outline-none" />
                      <span v-if="it.cantidad && it.cantidad > 1" class="text-[8px] font-black bg-gray-200 dark:bg-gray-700 px-1.5 py-0.5 rounded-full">x{{ it.cantidad }}</span>
                      <span v-if="it.garantia && it.garantia > 0" class="text-[8px] font-black bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                        🛡️ {{ formatearGarantia(it.garantia) }}
                      </span>
                    </div>
                    <p class="text-[8px] text-gray-400 font-black tracking-widest">{{ it.tipo.toUpperCase() }} {{ it.cantidad && it.cantidad > 1 ? `( $${it.precio_unitario?.toFixed(2)} c/u )` : '' }}</p>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex items-center bg-gray-50 dark:bg-gray-700 px-1 rounded">
                       <span class="text-[8px] text-gray-400 mr-1">$</span>
                       <input v-model.number="it.precio_total" @input="actualizarDesdePrecioTotal(it)" :readonly="esEntregado" type="number" step="0.01" class="w-16 py-0.5 px-1 text-[10px] font-bold bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded text-right outline-none focus:border-teal-500 transition-all" />
                    </div>
                    <button v-if="!esEntregado" @click="eliminarItemCarrito(it.uuid)" class="text-red-400 hover:text-red-600 transition-colors"><Icon icon="mdi:trash-can-outline" class="text-sm" /></button>
                  </div>
                </div>
              </div>
              
              <div v-if="!esEntregado" class="mt-4 mb-2 pt-2 border-t border-gray-100 dark:border-gray-800">
                <p class="text-[10px] font-black text-gray-500 uppercase tracking-widest mb-3 text-center">Catálogo</p>
                <div class="grid grid-cols-2 gap-3">
                  <button @click="abrirModalConfiguracionItem('servicio')" :disabled="esImposibleReparar" :class="esImposibleReparar ? 'opacity-50 cursor-not-allowed' : ''" class="py-3 px-2 rounded-xl transition-all duration-200 flex flex-col items-center justify-center gap-1 text-[10px] font-black uppercase bg-white dark:bg-gray-800 border border-green-200 dark:border-green-800 text-green-600 dark:text-green-400 shadow-sm hover:shadow-md hover:bg-green-50 dark:hover:bg-green-900/20 active:scale-95">
                    <Icon icon="mdi:wrench" class="text-xl mb-1" /> Agregar Servicio
                  </button>
                  <button @click="abrirModalConfiguracionItem('producto')" :disabled="esImposibleReparar" :class="esImposibleReparar ? 'opacity-50 cursor-not-allowed' : ''" class="py-3 px-2 rounded-xl transition-all duration-200 flex flex-col items-center justify-center gap-1 text-[10px] font-black uppercase bg-white dark:bg-gray-800 border border-blue-200 dark:border-blue-800 text-blue-600 dark:text-blue-400 shadow-sm hover:shadow-md hover:bg-blue-50 dark:hover:bg-blue-900/20 active:scale-95">
                    <Icon icon="mdi:package-variant" class="text-xl mb-1" /> Agregar Producto
                  </button>
                </div>
              </div>

              <div class="mt-3 pt-2 border-t border-gray-100 dark:border-gray-800">
                <div class="flex justify-between items-center px-1">
                   <span class="text-[9px] font-black text-gray-400 uppercase tracking-tighter">Subtotal Servicios y Productos:</span>
                   <span class="text-xs font-black text-gray-700 dark:text-gray-300">${{ totalVisibleFase2.toFixed(2) }}</span>
                </div>
              </div>

              <!-- Total Contado vs Crédito Cachéas en Fase 2 -->
              <div v-if="itemsAgregados.length > 0 || itemsRepuestosManuales.length > 0" class="mt-3 pt-2 border-t border-gray-200 dark:border-gray-700 space-y-2">
                <div class="grid grid-cols-2 gap-2">
                  <div class="bg-emerald-50 dark:bg-emerald-900/20 p-2 rounded-lg border border-emerald-100 dark:border-emerald-800/40 text-center">
                    <p class="text-[8px] font-black text-emerald-600 dark:text-emerald-400 uppercase tracking-wider">Contado</p>
                    <p class="text-sm font-black text-emerald-700 dark:text-emerald-300">${{ totalContadoFase2.toFixed(2) }}</p>
                  </div>
                  <div class="bg-purple-50 dark:bg-purple-900/20 p-2 rounded-lg border border-purple-100 dark:border-purple-800/40 text-center">
                    <p class="text-[8px] font-black text-purple-600 dark:text-purple-400 uppercase tracking-wider">Crédito Cachéas (+17%)</p>
                    <p class="text-sm font-black text-purple-700 dark:text-purple-300">${{ totalCacheasFase2.toFixed(2) }}</p>
                  </div>
                </div>
              </div>

              <!-- Repuestos Personalizados -->
              <div class="mt-4 pt-3 border-t-2 border-dashed border-gray-200 dark:border-gray-700">
                <label class="block text-[10px] font-black text-green-700 dark:text-green-400 uppercase mb-1.5 flex items-center gap-1.5">
                  <div class="p-1 bg-green-100 dark:bg-green-900/30 rounded-md">
                    <Icon icon="mdi:tools" class="text-xs" />
                  </div>
                  Repuestos
                </label>
                <div v-if="itemsRepuestosManuales.length > 0" class="space-y-2 mb-3">
                   <div v-for="(rep, idx) in itemsRepuestosManuales" :key="idx" class="flex items-center gap-2 bg-green-50/50 dark:bg-green-900/10 p-2 rounded-xl border border-green-100 dark:border-green-800 animate-fadeIn">
                      <div class="w-6 h-6 bg-green-500 text-white rounded-lg flex items-center justify-center text-[10px] font-black shrink-0">{{ idx + 1 }}</div>
                      <div class="flex-1">
                         <p class="text-[10px] font-black text-gray-700 dark:text-gray-300 uppercase leading-none">{{ rep.nombre }}</p>
                         <p class="text-[9px] font-bold text-gray-400">Repuesto Manual</p>
                      </div>
                      <div class="text-right px-2">
                         <p class="text-xs font-black text-green-600 dark:text-green-400">${{ rep.precio.toFixed(2) }}</p>
                      </div>
                      <button v-if="!esEntregado" @click="itemsRepuestosManuales.splice(idx, 1)" class="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors">
                         <Icon icon="mdi:trash-can-outline" />
                      </button>
                   </div>
                </div>

                <div v-if="!esEntregado" class="flex gap-2">
                  <div class="flex-1 relative">
                    <input 
                      v-model="form.nombreRepuestoManual" 
                      :disabled="esImposibleReparar"
                      type="text" 
                      placeholder="Nombre del repuesto..." 
                      class="w-full pl-3 pr-2 py-2 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded-xl text-[11px] font-bold outline-none focus:border-green-400 shadow-sm transition-all" 
                      :class="esImposibleReparar ? 'opacity-50 cursor-not-allowed' : ''"
                    />
                  </div>
                  <div class="w-24 relative">
                    <span class="absolute left-2 top-1/2 -translate-y-1/2 font-black text-green-500 text-[10px]">$</span>
                    <input 
                      v-model.number="form.precioRepuestoManual" 
                      :disabled="esImposibleReparar"
                      type="number" 
                      step="0.01" 
                      class="w-full pl-5 pr-2 py-2 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded-xl text-[11px] font-black text-green-600 outline-none focus:border-green-400 text-right shadow-sm transition-all" 
                      :class="esImposibleReparar ? 'opacity-50 cursor-not-allowed' : ''"
                      placeholder="0.00" 
                    />
                  </div>
                  <button 
                    @click="agregarRepuestoManual"
                    :disabled="esImposibleReparar"
                    :class="esImposibleReparar ? 'opacity-50 cursor-not-allowed' : ''"
                    class="p-2 bg-green-500 text-white rounded-xl hover:bg-green-600 transition-all shadow-md flex items-center justify-center shrink-0"
                  >
                    <Icon icon="mdi:plus-thick" class="text-lg" />
                  </button>
                </div>

                <div class="mt-4 pt-3 border-t border-gray-200 dark:border-gray-700 flex flex-col gap-1.5">
                   <div class="flex justify-between items-center bg-gray-50 dark:bg-gray-900/50 p-3 rounded-xl border border-gray-100 dark:border-gray-800 shadow-inner">
                      <div>
                         <p class="text-[11px] font-black text-gray-400 uppercase leading-none mb-1">Total</p>
                      </div>
                      <div class="text-right">
                         <span class="text-xl font-black text-green-600 dark:text-green-400 drop-shadow-sm">${{ totalVisibleFase2.toFixed(2) }}</span>
                      </div>
                   </div>
                </div>
              </div>
            </div>
            <button v-if="!esEstadoInalterable" @click="guardarCambiosYEstado" :disabled="guardando || !puedeFinalizarFase2" :class="['w-full py-3 rounded-xl transition-all flex items-center justify-center gap-2 font-black text-sm uppercase tracking-wider', guardando || !puedeFinalizarFase2 ? 'bg-gray-200 dark:bg-gray-800 text-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg active:scale-95']">
              <Icon v-if="guardando" icon="mdi:loading" class="animate-spin text-lg" />
              <Icon v-else icon="mdi:check-circle" class="text-lg" />
              {{ guardando ? 'Guardando...' : 'FINALIZAR FASE' }}
            </button>
            <div v-else class="p-4 bg-rose-50 dark:bg-rose-900/20 border-2 border-rose-100 rounded-xl text-center">
              <span class="text-[10px] font-black text-rose-600 uppercase">Fase Cerrada (Garantía)</span>
            </div>
          </div>
        </div>

        <!-- FASE 3: ENTREGA Y PAGO -->
        <div v-if="pasoActual === 3" class="bg-white dark:bg-gray-800 rounded-2xl shadow border border-gray-100 dark:border-gray-700 overflow-hidden animate-fadeIn">
          <div class="bg-gradient-to-r from-teal-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 px-3 py-1.5 border-b border-gray-100 dark:border-gray-700 flex justify-between items-center">
            <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
              <div class="p-1.5 bg-teal-100 dark:bg-teal-900/30 rounded-lg mr-2 shadow-sm">
                <Icon icon="mdi:handshake-outline" class="text-teal-600 dark:text-teal-400 text-lg" />
              </div>
              Proceso de Entrega
            </h2>
            <div class="text-[9px] font-black px-2 py-0.5 bg-white dark:bg-gray-700 text-teal-600 dark:text-teal-400 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 tracking-widest uppercase">Fase 3</div>
          </div>
          <div class="p-3 space-y-3">
            <div class="space-y-3">
               <div class="bg-gray-50/50 p-2 rounded-xl border border-gray-100 dark:bg-gray-900/30 dark:border-gray-800">
                <label class="block text-[9px] font-black text-gray-500 uppercase tracking-wider mb-1">Técnico Entrega <span class="text-red-500">*</span></label>
                   <div class="mt-1 flex items-center justify-between bg-teal-50 dark:bg-teal-900/20 p-1 px-2 rounded-lg border border-teal-100 dark:border-teal-800/40">
                      <span class="text-[9px] font-black text-teal-700 dark:text-teal-300 truncate">
                        ✓ {{ tecnicos.find(x => x.idTecnico === formPago.tecnicoEntrega)?.nombre || 'Técnico' }} {{ tecnicos.find(x => x.idTecnico === formPago.tecnicoEntrega)?.apellido || '' }}
                      </span>
                   </div>
                </div>
               <div class="grid grid-cols-2 gap-2">
                  <div class="bg-emerald-50/50 p-2 rounded-xl border border-emerald-100 dark:bg-emerald-900/10 dark:border-emerald-800/40">
                    <label class="block text-[9px] font-black text-emerald-600 dark:text-emerald-400 uppercase tracking-wider mb-1">Fecha de Salida</label>
                    <input v-model="form.fechaEntrega" type="datetime-local" class="w-full bg-transparent text-[10px] font-bold text-gray-700 dark:text-white outline-none focus:border-emerald-500" />
                  </div>
                  <div class="bg-indigo-50/50 p-2 rounded-xl border border-indigo-100 dark:bg-indigo-900/10 dark:border-indigo-800/40">
                    <label class="block text-[9px] font-black text-indigo-600 dark:text-indigo-400 uppercase tracking-wider mb-1">Fecha de Pago</label>
                    <input v-model="form.fechaPago" type="datetime-local" class="w-full bg-transparent text-[10px] font-bold text-gray-700 dark:text-white outline-none focus:border-indigo-500" />
                  </div>
               </div>
            </div>
          </div>

            <div class="bg-teal-50/30 dark:bg-teal-900/10 p-3 rounded-xl border border-teal-100 dark:border-teal-800/40">
              <div class="flex justify-between items-center mb-2">
                <h3 class="font-black text-gray-800 dark:text-white flex items-center text-[9px] uppercase tracking-wider leading-none"><Icon icon="mdi:cart-plus" class="mr-2 text-teal-600 text-lg" /> Venta Adicional</h3>
              </div>

              <div v-if="itemsEntrega.length > 0" class="space-y-1.5 mb-2">
                <div v-for="it in itemsEntrega" :key="it.uuid" class="flex items-center justify-between p-2 bg-white dark:bg-gray-800 rounded-lg border border-teal-100 dark:border-teal-900/30 shadow-sm">
                   <div class="flex-1 overflow-hidden mr-2">
                       <div class="flex items-center gap-2 flex-wrap">
                         <input v-model="it.nombre" :readonly="esEntregado || it.tipo === 'producto'" class="flex-1 text-[9px] font-bold text-gray-800 dark:text-white uppercase bg-transparent border-b border-transparent focus:border-teal-500 outline-none" :class="{'cursor-default': it.tipo === 'producto'}" />
                         <span v-if="it.cantidad && it.cantidad > 1" class="text-[8px] font-black bg-gray-200 dark:bg-gray-700 px-1.5 py-0.5 rounded-full">x{{ it.cantidad }}</span>
                         <span v-if="it.garantia && it.garantia > 0" class="text-[8px] font-black bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                           🛡️ {{ formatearGarantia(it.garantia) }}
                         </span>
                       </div>
                      <p class="text-[8px] text-gray-400 font-black tracking-widest">${{ it.precio_total?.toFixed(2) }} ({{ it.tipo.toUpperCase() }})</p>
                   </div>
                   <div class="flex items-center gap-2">
                      <div class="flex items-center bg-teal-50 dark:bg-gray-700 px-1 rounded">
                         <span class="text-[8px] text-gray-400 mr-1">$</span>
                         <input v-model.number="it.precio_total" @input="actualizarDesdePrecioTotalFase3(it)" :readonly="esEntregado" type="number" step="0.01" class="w-16 py-0.5 px-1 text-[10px] font-bold bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded text-right outline-none focus:border-teal-500 transition-all" />
                      </div>
                      <button v-if="!esEntregado" @click="itemsEntrega = itemsEntrega.filter(x => x.uuid !== it.uuid)" class="text-red-400"><Icon icon="mdi:trash-can-outline" /></button>
                   </div>
                </div>
              </div>
              
              <div class="mt-2 text-center" v-if="!esEntregado && !esGarantia">
                <button @click="abrirModalConfiguracionItemFase3('producto')" class="px-4 py-2 w-full rounded-lg transition-all duration-200 flex items-center justify-center gap-2 text-[10px] font-black uppercase bg-teal-100 dark:bg-teal-900/30 text-teal-700 dark:text-teal-300 hover:bg-teal-200 dark:hover:bg-teal-800/50">
                  <Icon icon="mdi:plus-circle" class="text-sm" /> Agregar Producto Extra
                </button>
              </div>
            </div>

            <div class="bg-gray-50/30 dark:bg-gray-900/20 p-3 rounded-xl border border-gray-200 dark:border-gray-700">
               <div class="mb-3 bg-white dark:bg-gray-800/40 p-2 rounded-lg border border-gray-100 dark:border-gray-700 shadow-sm flex items-center justify-between">
                  <div class="flex items-center gap-2">
                     <Icon icon="mdi:wrench-clock" class="text-teal-500" />
                     <span class="text-[9px] font-black text-gray-400 uppercase">Reparación Anterior (Fase 2)</span>
                  </div>
                  <span class="text-xs font-black text-teal-600 tracking-tight">${{ (orden?.precioTotalUsd || 0).toFixed(2) }}</span>
               </div>

              <h3 class="font-black text-gray-800 dark:text-white mb-2 flex items-center text-[9px] uppercase tracking-wider leading-none"><Icon icon="mdi:cash-register" class="mr-2 text-teal-600 text-lg" /> Salida y Cobro Final</h3>
              
              <div class="grid grid-cols-2 gap-3 mb-3">
                 <div class="bg-white dark:bg-gray-800 p-2 rounded-lg border border-gray-100 dark:border-gray-700 shadow-sm text-center">
                    <label class="block text-[8px] font-black text-gray-400 uppercase mb-1">Tipo de Venta</label>
                    <div class="flex gap-1 p-1 bg-gray-100 dark:bg-gray-900 rounded-lg">
                       <button :disabled="esEntregado" @click="tipoVenta = 'CONTADO'" :class="[tipoVenta === 'CONTADO' ? 'bg-white dark:bg-gray-700 text-teal-600 shadow-sm' : 'text-gray-400', esEntregado ? 'opacity-50' : '']" class="flex-1 py-1 text-[9px] font-black uppercase rounded-md transition-all">Contado</button>
                       <button :disabled="esEntregado" @click="tipoVenta = 'CREDITO'; if(cuotas.lista.length === 0) calcularCuotas()" :class="[tipoVenta === 'CREDITO' ? 'bg-white dark:bg-gray-700 text-purple-600 shadow-sm' : 'text-gray-400', esEntregado ? 'opacity-50' : '']" class="flex-1 py-1 text-[9px] font-black uppercase rounded-md transition-all">Crédito</button>
                    </div>
                 </div>
                 <div class="bg-white dark:bg-gray-800 p-2 rounded-lg border border-gray-100 dark:border-gray-700 shadow-sm">
                    <label class="block text-[8px] font-black text-gray-500 uppercase mb-1 px-1">Tasa Cambio</label>
                    <select v-model="formPago.idTasaVenta" disabled class="w-full px-1 py-1 bg-gray-50 dark:bg-gray-800/50 text-xs font-black text-gray-500 outline-none cursor-not-allowed">
                       <option value="0">TASA AUTOMÁTICA</option>
                       <option v-for="t in tasasVenta" :key="t.idTasaVenta" :value="t.idTasaVenta">{{ t.precio_usd_bs }} ({{ t.nombreFuente || 'BCV' }})</option>
                    </select>
                 </div>
              </div>

              <div v-if="tipoVenta === 'CREDITO'" class="mb-4 space-y-3 animate-fadeIn">
                 <div class="grid grid-cols-2 gap-2">
                    <button @click="seleccionarCachéas()" :class="tipoCredito === 'cacheas' ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20 text-purple-700' : 'border-gray-100 dark:border-gray-700 text-gray-400'" class="p-2 rounded-xl border-2 text-left transition-all">
                       <p class="text-[10px] font-black uppercase">Cachéas</p>
                       <p class="text-[8px] font-bold opacity-70">+17% Recargo</p>
                    </button>
                    <button @click="tipoCredito = 'empresa'" :class="tipoCredito === 'empresa' ? 'border-teal-500 bg-teal-50 dark:bg-teal-900/20 text-teal-700' : 'border-gray-100 dark:border-gray-700 text-gray-400'" class="p-2 rounded-xl border-2 text-left transition-all">
                       <p class="text-[10px] font-black uppercase">Empresa</p>
                       <p class="text-[8px] font-bold opacity-70">Sin Recargo</p>
                    </button>
                 </div>

                 <div v-if="tipoCredito === 'cacheas'" class="space-y-4 animate-fadeIn">
                     <div class="p-4 bg-gradient-to-r from-purple-600 to-indigo-700 rounded-2xl shadow-xl border border-white/10 relative overflow-hidden group/card">
                        <div class="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16 blur-2xl"></div>
                        
                        <div class="relative z-10 flex flex-wrap items-center justify-between gap-4">
                           <div class="flex-1 min-w-[150px]">
                              <div class="flex items-center gap-2 mb-1">
                                 <Icon icon="mdi:calculator-variant" class="text-purple-200 text-xs" />
                                 <label class="text-[9px] font-black text-purple-100 uppercase tracking-widest opacity-80">TOTAL CRÉDITO CACHÉAS</label>
                              </div>
                              <div class="flex items-center bg-white/10 rounded-xl px-3 py-2 border border-white/10 shadow-inner">
                                 <span class="font-black text-white/50 text-xl mr-2">$</span>
                                 <input 
                                    v-model.number="total_con_recargo_cacheas" 
                                    @input="ajustarItemsDesdeTotalCacheas" 
                                    type="number" 
                                    step="0.01" 
                                    class="w-full font-black text-3xl text-white bg-transparent outline-none text-right [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" 
                                 />
                              </div>
                           </div>

                           <div class="flex gap-4">
                              <div class="text-right">
                                 <span class="text-[8px] font-black text-purple-200 uppercase tracking-tighter opacity-60">Monto Base</span>
                                 <p class="text-sm font-black text-white leading-none mt-1">${{ subtotalOriginal.toFixed(2) }}</p>
                              </div>
                              <div class="h-8 w-[1px] bg-white/20 self-center"></div>
                              <div class="text-right">
                                 <span class="text-[8px] font-black text-orange-200 uppercase tracking-tighter opacity-60">Recargo (+17%)</span>
                                 <p class="text-sm font-black text-orange-300 leading-none mt-1">+${{ recargoTotal.toFixed(2) }}</p>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div class="bg-gray-50/50 dark:bg-gray-900/50 rounded-3xl border border-gray-200 dark:border-gray-800 p-6 space-y-4">
                        <div class="flex items-center justify-between mb-2">
                           <h4 class="text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-[0.2em] flex items-center gap-2">
                              <div class="p-1.5 bg-purple-100 dark:bg-purple-900/30 rounded-lg">
                                 <Icon icon="mdi:format-list-bulleted-type" class="text-purple-600 dark:text-purple-400" />
                              </div>
                              Desglose y Ajuste por Item
                           </h4>
                           <span class="text-[8px] font-bold text-gray-400 bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-full uppercase tracking-widest">Sincronizado</span>
                        </div>
                        
                        <div v-if="orden.montoDiagnostico > 0" class="flex items-center justify-between gap-4 p-4 bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm transition-all hover:shadow-md group/item">
                           <div class="flex-1 min-w-0">
                              <p class="text-[11px] font-black text-gray-700 dark:text-gray-300 uppercase tracking-wide group-hover/item:text-purple-600 transition-colors">Diagnóstico ({{ orden.tipoDiagnostico }})</p>
                              <div class="flex items-center gap-2 mt-0.5">
                                 <span class="text-[9px] font-bold text-gray-400">PRECIO BASE:</span>
                                 <span class="text-[10px] font-black text-gray-600 dark:text-gray-400">${{ (orden.montoDiagnostico || 0).toFixed(2) }}</span>
                              </div>
                           </div>
                           <div class="w-32 shrink-0">
                              <div class="relative group/input">
                                 <span class="absolute left-3 top-1/2 -translate-y-1/2 text-purple-500 font-black text-[10px] transition-transform group-focus-within/input:scale-110">$</span>
                                 <input 
                                    :value="redondear((orden.montoDiagnostico || 0) * 1.17)" 
                                    type="number" 
                                    readonly
                                    class="w-full pl-7 pr-3 py-2.5 bg-purple-50/30 dark:bg-purple-900/20 border-2 border-purple-100/50 dark:border-purple-800/30 rounded-xl text-xs font-black text-purple-700 dark:text-purple-300 text-right outline-none focus:border-purple-500 focus:bg-white dark:focus:bg-gray-700 transition-all shadow-inner cursor-not-allowed opacity-70"
                                 />
                              </div>
                           </div>
                        </div>

                        <div v-for="it in todosLosItems" :key="it.uuid" class="flex items-center justify-between gap-4 p-4 bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm transition-all hover:shadow-md group/item">
                           <div class="flex-1 min-w-0">
                              <div class="flex items-center gap-2">
                                 <div class="w-1.5 h-1.5 rounded-full" :class="it.tipo === 'servicio' ? 'bg-green-500' : 'bg-blue-500'"></div>
                                 <p class="text-[11px] font-black text-gray-700 dark:text-gray-300 uppercase tracking-wide group-hover/item:text-purple-600 transition-colors truncate">{{ it.nombre }}</p>
                                 <span v-if="it.cantidad && it.cantidad > 1" class="text-[8px] font-black bg-gray-200 dark:bg-gray-700 px-1.5 py-0.5 rounded-full">x{{ it.cantidad }}</span>
                                 <span v-if="it.garantia && it.garantia > 0" class="text-[8px] font-black bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                                   🛡️ {{ formatearGarantia(it.garantia) }}
                                 </span>
                              </div>
                              <div class="flex items-center gap-2 mt-0.5">
                                 <span class="text-[9px] font-bold text-gray-400">PRECIO BASE:</span>
                                 <span class="text-[10px] font-black text-gray-600 dark:text-gray-400">${{ (it.precio_unitario || it.precio || 0).toFixed(2) }}</span>
                              </div>
                           </div>
                           <div class="w-32 shrink-0">
                              <div class="relative group/input">
                                 <span class="absolute left-3 top-1/2 -translate-y-1/2 text-purple-500 font-black text-[10px] transition-transform group-focus-within/input:scale-110">$</span>
                                 <input 
                                    :value="redondear(((it.precio_unitario || it.precio || 0) * (it.cantidad || 1)) * 1.17)" 
                                    type="number" 
                                    readonly
                                    class="w-full pl-7 pr-3 py-2.5 bg-purple-50/30 dark:bg-purple-900/20 border-2 border-purple-100/50 dark:border-purple-800/30 rounded-xl text-xs font-black text-purple-700 dark:text-purple-300 text-right outline-none focus:border-purple-500 focus:bg-white dark:focus:bg-gray-700 transition-all shadow-inner cursor-not-allowed opacity-70"
                                 />
                              </div>
                           </div>
                        </div>
                        
                        <div class="flex items-center justify-center gap-2 pt-2">
                           <Icon icon="mdi:information-outline" class="text-purple-400 text-xs" />
                           <p class="text-[9px] text-gray-400 font-bold italic opacity-80 uppercase tracking-tighter">Modificar el total global no alterará los precios unitarios.</p>
                        </div>
                     </div>

                     <div class="p-5 bg-white dark:bg-gray-800 rounded-2xl border-2 border-purple-100 dark:border-purple-900/40 space-y-5 shadow-sm">
                        <div>
                           <label class="block text-[10px] font-black text-gray-500 uppercase mb-2 tracking-wider">Monto de la Inicial (USD)</label>
                           <div class="relative group">
                              <span class="absolute left-3 top-1/2 -translate-y-1/2 font-black text-teal-600 group-focus-within:scale-110 transition-transform">$</span>
                              <input v-model.number="cuotas.inicialPersonalizada" @input="actualizarInicial" type="number" step="0.01" class="w-full pl-8 pr-4 py-3 bg-gray-50 dark:bg-gray-900/50 rounded-2xl font-black text-xl text-teal-600 outline-none border-2 border-gray-200 dark:border-gray-700 focus:border-teal-500 transition-all shadow-inner" />
                           </div>
                        </div>

                        <div v-if="cuotas.inicial > 0" class="p-4 bg-emerald-50/50 dark:bg-emerald-900/10 rounded-2xl border-2 border-emerald-100 dark:border-emerald-800/40 space-y-3 animate-fadeIn">
                           <label class="block text-[10px] font-black text-emerald-700 dark:text-emerald-400 uppercase tracking-widest flex items-center gap-2">
                              <Icon icon="mdi:bank" /> Método Pago Inicial
                           </label>
                           <select v-model="formPago.idMetodoPagoInicial" @change="onMetodoPagoInicialChange()" class="w-full px-4 py-2.5 bg-white dark:bg-gray-800 rounded-xl text-xs font-bold outline-none border-2 border-gray-200 dark:border-gray-700 focus:border-emerald-500 transition-all shadow-sm">
                              <option value="0">SELECCIONE MÉTODO...</option>
                              <option v-for="m in metodosPago" :key="m.idMetodoPago" :value="m.idMetodoPago">{{ m.nombre }}</option>
                           </select>

                           <div v-if="esPagoMovilInicial || esTransferenciaInicial || esPuntoVentaInicial" class="space-y-3 animate-slideUp">
                              <input v-model="formPago.referenciaInicial" type="text" :placeholder="esPuntoVentaInicial ? '4 últimos dígitos ref. punto' : 'Número de Referencia'" class="w-full px-4 py-2.5 bg-white dark:bg-gray-800 rounded-xl text-xs font-bold outline-none border-2 border-gray-200 dark:border-gray-700 focus:border-emerald-500 transition-all shadow-sm" />
                           </div>
                        </div>

                        <div class="overflow-hidden rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm">
                           <table class="w-full text-[10px]">
                              <thead class="bg-gray-50 dark:bg-gray-900/50">
                                 <tr class="text-gray-400 uppercase font-black tracking-tighter">
                                    <th class="p-3 text-left">N°</th>
                                    <th class="p-3 text-left">Fecha</th>
                                    <th class="p-3 text-right">Monto</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr v-for="(c, i) in cuotas.lista" :key="i" class="border-t border-gray-50 dark:border-gray-800 hover:bg-gray-50/50 transition-colors">
                                    <td class="p-3 font-bold text-gray-500">{{ i + 1 }}</td>
                                    <td class="p-3 font-semibold text-gray-700 dark:text-gray-300">{{ c.fechaPago }}</td>
                                    <td class="p-3 text-right font-black text-teal-600 text-sm">$${{ c.montoUsd.toFixed(2) }}</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>

                 <div v-if="tipoCredito === 'empresa'" class="p-3 bg-white dark:bg-gray-800 rounded-xl border border-teal-100 dark:border-teal-900/40 space-y-3 shadow-sm">
                    <div>
                       <label class="block text-[9px] font-black text-gray-500 uppercase mb-1">Fecha de Pago Acordada</label>
                       <input v-model="creditoEmpresa.fechaPagoAcordada" type="date" class="w-full px-2 py-1.5 bg-white dark:bg-gray-900 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-teal-500 transition-all shadow-sm" />
                    </div>
                    <div>
                       <label class="block text-[9px] font-black text-gray-500 uppercase mb-1">Observaciones</label>
                       <textarea v-model="creditoEmpresa.observaciones" rows="2" class="w-full px-2 py-1.5 bg-white dark:bg-gray-900 rounded-lg text-[10px] outline-none font-medium resize-none border-2 border-gray-300 dark:border-gray-600 focus:border-teal-500 transition-all shadow-sm" placeholder="Detalles del acuerdo..."></textarea>
                    </div>

                    <div class="p-2 bg-emerald-50/50 dark:bg-emerald-900/10 rounded-xl border border-emerald-100 dark:border-emerald-800/40 space-y-2">
                       <label class="block text-[9px] font-black text-emerald-700 dark:text-emerald-400 uppercase">Abono Inicial <span class="text-gray-400 font-medium normal-case">(opcional)</span></label>
                       <div class="relative">
                          <span class="absolute left-2 top-1/2 -translate-y-1/2 font-black text-emerald-600 text-[10px]">$</span>
                          <input v-model.number="creditoEmpresa.abonoInicial" @input="calcularAbonoEmpresa" type="number" step="0.01" min="0" placeholder="0.00"
                             class="w-full pl-5 pr-2 py-1.5 bg-white dark:bg-gray-900 rounded-lg text-[10px] font-black text-emerald-600 outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-emerald-500 transition-all shadow-sm text-right" />
                       </div>

                       <div v-if="creditoEmpresa.abonoInicial > 0" class="space-y-2 animate-fadeIn">
                          <label class="block text-[9px] font-black text-gray-500 uppercase">Método de Pago del Abono 💳</label>
                          <select v-model="creditoEmpresa.idMetodoPagoAbono" @change="onMetodoPagoAbonoEmpresaChange" class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-emerald-500 transition-all">
                             <option value="0">SELECCIONE MÉTODO...</option>
                             <option v-for="m in metodosPago" :key="m.idMetodoPago" :value="m.idMetodoPago">{{ m.nombre }}</option>
                          </select>
                          <div v-if="esAbonoEmpresaPuntoVenta" class="animate-fadeIn">
                             <input 
                               v-model="creditoEmpresa.referenciaAbono"
                               type="text"
                               inputmode="numeric"
                               maxlength="4"
                               placeholder="4 dígitos ref. punto"
                               @input="creditoEmpresa.referenciaAbono = creditoEmpresa.referenciaAbono.replace(/[^0-9]/g, '').slice(0, 4)"
                               class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] text-center font-black outline-none border-2 border-orange-400 dark:border-orange-600 focus:border-orange-500 transition-all shadow-sm tracking-widest font-mono"
                             />
                          </div>
                          <div v-if="esAbonoEmpresaMovilOTransferencia" class="animate-fadeIn">
                             <input v-model="creditoEmpresa.referenciaAbono" type="text" placeholder="N° Referencia"
                               class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-emerald-500 transition-all shadow-sm" />
                          </div>
                       </div>
                    </div>

                    <div class="rounded-xl border border-teal-100 dark:border-teal-800/40 overflow-hidden">
                       <div class="flex justify-between items-center px-3 py-1.5 bg-teal-50 dark:bg-teal-900/20">
                          <span class="text-[9px] font-black text-teal-600 dark:text-teal-400 uppercase tracking-wider">Total</span>
                          <span class="text-[10px] font-black text-teal-700 dark:text-teal-300">${{ subtotalOriginal.toFixed(2) }}</span>
                       </div>
                       <div v-if="creditoEmpresa.abonoInicial > 0" class="flex justify-between items-center px-3 py-1.5 bg-emerald-50 dark:bg-emerald-900/20 border-t border-emerald-100 dark:border-emerald-800/30">
                          <span class="text-[9px] font-black text-emerald-600 dark:text-emerald-400 uppercase tracking-wider flex items-center gap-1">
                            <span class="text-[8px]">↓</span> Abono
                          </span>
                          <span class="text-[10px] font-black text-emerald-600 dark:text-emerald-400">- ${{ (creditoEmpresa.abonoInicial || 0).toFixed(2) }}</span>
                       </div>
                       <div v-if="creditoEmpresa.abonoInicial > 0" class="flex justify-between items-center px-3 py-2 bg-red-50 dark:bg-red-900/20 border-t border-red-100 dark:border-red-800/30">
                          <span class="text-[9px] font-black text-red-600 dark:text-red-400 uppercase tracking-wider flex items-center gap-1">
                            <span class="text-[8px]">⏳</span> Pendiente
                          </span>
                          <span class="text-xs font-black text-red-600 dark:text-red-400">${{ Math.max(0, subtotalOriginal - (creditoEmpresa.abonoInicial || 0)).toFixed(2) }}</span>
                       </div>
                    </div>
                 </div>
              </div>

              <div v-if="tipoVenta === 'CONTADO' || (tipoVenta === 'CREDITO' && tipoCredito === 'cacheas' && cuotas.inicial === 0)" class="space-y-3">
                 <div>
                    <label class="block text-[9px] font-black text-gray-500 uppercase tracking-wider mb-2">Método de Pago 💳</label>
                    <div class="grid grid-cols-2 gap-2">
                       <button v-for="m in metodosPago" :key="m.idMetodoPago" 
                          @click="formPago.idMetodoPago = m.idMetodoPago; onMetodoPagoChange()" 
                          :class="formPago.idMetodoPago === m.idMetodoPago ? 'bg-teal-500 text-white shadow-lg' : 'bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400 border border-gray-100 dark:border-gray-700'" 
                          class="py-2 rounded-xl text-[10px] font-black uppercase transition-all flex items-center justify-center gap-1">
                          <Icon :icon="m.tipo === 'pago_movil' ? 'mdi:cellphone' : (m.tipo === 'punto_venta' ? 'mdi:credit-card' : (m.tipo === 'transferencia' ? 'mdi:bank-transfer' : 'mdi:cash'))" />
                          {{ m.nombre }}
                       </button>
                    </div>
                 </div>

                 <!-- ✅ PAGO MÓVIL SIN BANCO DESTINO -->
                 <div v-if="esPagoMovil" class="p-3 bg-blue-50/50 dark:bg-blue-900/10 rounded-xl border border-blue-100 dark:border-blue-800/40 space-y-2 animate-fadeIn">
                    <div class="flex items-center gap-2 mb-1"><Icon icon="mdi:cellphone" class="text-blue-500" /><span class="text-[9px] font-black uppercase text-blue-700 dark:text-blue-400">Pago Móvil</span></div>
                    <div class="grid grid-cols-2 gap-2">
                       <input v-model="pagoMovil.cedula" type="text" placeholder="Cédula" class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-blue-500 transition-all" />
                       <input v-model="pagoMovil.telefono" type="text" placeholder="Teléfono" class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-blue-500 transition-all" />
                    </div>
                    <input v-model="formPago.referencia" type="text" placeholder="N° de Referencia Bancaria" class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-blue-500 transition-all shadow-sm" />
                 </div>

                 <div v-if="esTransferencia" class="p-3 bg-purple-50/50 dark:bg-purple-900/10 rounded-xl border border-purple-100 dark:border-purple-800/40 space-y-2 animate-fadeIn">
                    <div class="flex items-center gap-2 mb-1"><Icon icon="mdi:bank-transfer" class="text-purple-500" /><span class="text-[9px] font-black uppercase text-purple-700 dark:text-purple-400">Transferencia</span></div>
                    <select v-model="transferencia.banco_destino" class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-purple-500 transition-all shadow-sm">
                       <option value="">BANCO DESTINO...</option>
                       <option v-for="b in bancosEmpresa" :key="b.id" :value="b.nombre">{{ b.nombre }}</option>
                    </select>
                    <input v-model="transferencia.numero_cuenta" type="text" readonly :placeholder="transferencia.banco_destino ? bancosEmpresa.find(b => b.nombre === transferencia.banco_destino).cuenta : 'Cuenta Destino...'" class="w-full px-2 py-1.5 bg-purple-100/30 dark:bg-purple-900/30 rounded-lg text-[10px] font-bold outline-none font-mono text-center" />
                    <div class="grid grid-cols-2 gap-2">
                       <select v-model="transferencia.banco_origen" class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-purple-500 transition-all">
                          <option value="">BANCO ORIGEN...</option>
                          <option v-for="b in bancosVenezuela" :key="b" :value="b">{{ b }}</option>
                       </select>
                       <input v-model="formPago.referencia" type="text" placeholder="Referencia" class="w-full px-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold outline-none border-2 border-gray-300 dark:border-gray-600 focus:border-purple-500 transition-all shadow-sm" />
                    </div>
                 </div>

                 <div v-if="esPuntoVenta" class="p-3 bg-orange-50/50 dark:bg-orange-900/10 rounded-xl border border-orange-100 dark:border-orange-800/40 space-y-2 animate-fadeIn">
                    <div class="flex items-center gap-2 mb-1"><Icon icon="mdi:credit-card" class="text-orange-500" /><span class="text-[9px] font-black uppercase text-orange-700 dark:text-orange-400">Punto de Venta</span></div>
                    <input 
                      v-model="puntoVenta.referencia"
                      type="text"
                      inputmode="numeric"
                      maxlength="4"
                      placeholder="4 dígitos"
                      @input="puntoVenta.referencia = puntoVenta.referencia.replace(/[^0-9]/g, '').slice(0, 4)"
                      class="w-full px-2 py-2 bg-white dark:bg-gray-800 rounded-lg text-sm text-center font-black outline-none border-2 border-orange-400 dark:border-orange-600 focus:border-orange-500 transition-all shadow-sm tracking-widest font-mono"
                    />
                 </div>
              </div>

              <div class="grid grid-cols-2 gap-3 items-end pt-2 border-t border-gray-100 dark:border-gray-800">
                  <div>
                    <label class="block text-[8px] font-black text-orange-500 uppercase mb-1 px-1 tracking-widest leading-none">Descuento USD</label>
                    <div class="relative">
                       <span class="absolute left-2 top-1/2 -translate-y-1/2 font-black text-orange-500 text-xs">$</span>
                       <input v-model.number="formPago.descuento" type="number" step="0.01" min="0" class="w-full pl-5 pr-2 py-2 font-black text-md text-orange-600 dark:text-orange-400 rounded-xl bg-orange-50 dark:bg-gray-900/50 outline-none text-right shadow-inner border border-orange-100 dark:border-orange-900/30" />
                    </div>
                  </div>
                  <div>
                     <label class="block text-[8px] font-black text-teal-500 uppercase mb-1 px-1 tracking-widest leading-none">Total USD</label>
                     <div class="relative">
                        <span class="absolute left-2 top-1/2 -translate-y-1/2 font-black text-teal-600 text-xs">$</span>
                        <input :value="totalGeneralPagar.toFixed(2)" type="number" readonly class="w-full pl-5 pr-2 py-2 font-black text-lg text-teal-700 dark:text-teal-400 rounded-xl bg-teal-50 dark:bg-gray-900/50 outline-none text-right shadow-inner" />
                     </div>
                  </div>
               </div>
               <div class="flex justify-end mt-1">
                  <div class="relative w-1/2">
                     <span class="absolute left-2 top-1/2 -translate-y-1/2 font-black text-gray-400 text-[8px]">Bs</span>
                     <input :value="(totalGeneralPagar * tasaVirtual).toLocaleString('es-VE', { minimumFractionDigits: 2 })" type="text" readonly class="w-full pl-6 pr-2 py-1.5 bg-white dark:bg-gray-800 rounded-lg text-[10px] font-bold text-right text-gray-500 outline-none" />
                  </div>
               </div>
               
               <button v-if="!esEntregado && !esGarantia" @click="procesarEntrega" :disabled="guardando || !puedeFinalizarFase3" :class="['w-full py-4 rounded-2xl transition-all flex flex-col items-center justify-center gap-0.5 font-black uppercase shadow-lg active:scale-95 mt-4', guardando || !puedeFinalizarFase3 ? 'bg-gray-200 dark:bg-gray-800 text-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-teal-500 to-emerald-600 text-white']">
               <div class="flex items-center gap-2">
                  <Icon v-if="guardando" icon="mdi:loading" class="animate-spin text-xl" />
                  <Icon v-else icon="mdi:cash-check" class="text-xl" />
                  <span class="text-sm tracking-[0.2em] transform transition-all group-hover:scale-110">{{ guardando ? 'PROCESANDO...' : 'LIQUIDAR Y ENTREGAR' }}</span>
               </div>
               <span class="text-[9px] opacity-75">Sincronizará inventario y registrará en caja</span>
           </button>
           <div v-else class="mt-4 p-4 bg-emerald-50 dark:bg-emerald-900/20 border-2 border-emerald-100 rounded-2xl text-center">
               <div class="flex items-center justify-center gap-2 text-emerald-600 dark:text-emerald-400 mb-1">
                  <Icon icon="mdi:check-decagram" class="text-2xl" />
                  <span class="text-xs font-black uppercase tracking-widest">Orden Liquidada</span>
               </div>
               <p class="text-[10px] font-bold text-emerald-500 opacity-70">El equipo ya fue entregado y el pago procesado.</p>
           </div>
        </div>
      </div>
    </div>
  </div>

    <!-- MODAL DE CONFIGURACIÓN DE ÍTEM - RESPONSIVE CORREGIDO -->
    <Teleport to="body">
      <div v-if="showItemConfigModal" class="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-2 sm:p-4 md:p-6" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="closeItemConfigModal"></div>

        <div class="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md mx-auto flex flex-col transform transition-all scale-100 animate-fadeIn max-h-[95vh] overflow-y-auto">
          <div class="p-4 sm:p-5 md:p-6 bg-gradient-to-r" :class="itemConfigTipo === 'servicio' ? 'from-green-600 to-emerald-700' : 'from-blue-600 to-indigo-700'">
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2 sm:gap-3">
                <div class="p-2 bg-white/20 rounded-xl">
                  <Icon :icon="itemConfigTipo === 'servicio' ? 'mdi:wrench' : 'mdi:package-variant'" class="text-xl sm:text-2xl text-white" />
                </div>
                <div>
                  <h3 class="text-base sm:text-lg font-black text-white uppercase tracking-tighter">Configurar {{ itemConfigTipo === 'servicio' ? 'Servicio' : 'Producto' }}</h3>
                  <p class="text-[8px] sm:text-[9px] font-bold text-white/70 uppercase tracking-widest">Ajusta precio, garantía y cantidad</p>
                </div>
              </div>
              <button @click="closeItemConfigModal" class="p-1.5 sm:p-2 hover:bg-white/10 rounded-xl transition-all">
                <Icon icon="mdi:close" class="text-xl sm:text-2xl text-white" />
              </button>
            </div>
          </div>
          
          <div class="p-4 sm:p-5 md:p-6 space-y-3 sm:space-y-4 bg-gray-50/50 dark:bg-gray-900/50">
            <div class="bg-white dark:bg-gray-800 p-3 sm:p-4 rounded-xl border border-gray-100 dark:border-gray-700">
              <p class="text-[8px] sm:text-[9px] font-black text-gray-400 uppercase tracking-wider mb-1">Ítem seleccionado</p>
              <p class="font-bold text-gray-800 dark:text-white text-xs sm:text-sm break-words">{{ itemConfigSeleccionado?.nombre || itemConfigSeleccionado?.display || '' }}</p>
            </div>

            <div>
              <label class="block text-[9px] sm:text-[10px] font-black text-gray-500 uppercase tracking-wider mb-1.5 sm:mb-2">PRECIO UNITARIO (USD)</label>
              <div class="relative">
                <span class="absolute left-3 top-1/2 -translate-y-1/2 font-black text-green-600 text-sm">$</span>
                <input 
                  v-model.number="itemConfigPrecio" 
                  type="number" 
                  step="0.01" 
                  min="0.01"
                  class="w-full pl-8 pr-3 py-2.5 sm:py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl text-base sm:text-lg font-black text-green-600 dark:text-green-400 outline-none focus:border-green-500 transition-all text-right"
                />
              </div>
            </div>

            <div>
              <label class="block text-[9px] sm:text-[10px] font-black text-gray-500 uppercase tracking-wider mb-1.5 sm:mb-2">GARANTÍA (DÍAS)</label>
              <div class="flex gap-2">
                <input 
                  v-model.number="itemConfigGarantia" 
                  type="number" 
                  step="1" 
                  min="0"
                  class="flex-1 px-2 sm:px-3 py-2.5 sm:py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl text-xs sm:text-sm font-bold outline-none focus:border-green-500 transition-all"
                />
                <div class="px-2 sm:px-3 py-2.5 sm:py-3 bg-gray-100 dark:bg-gray-700 rounded-xl text-[8px] sm:text-[9px] font-black text-gray-500 uppercase tracking-wider flex items-center whitespace-nowrap">
                  {{ formatearGarantia(itemConfigGarantia || 0) }}
                </div>
              </div>
            </div>

            <div>
              <label class="block text-[9px] sm:text-[10px] font-black text-gray-500 uppercase tracking-wider mb-1.5 sm:mb-2">CANTIDAD</label>
              <div class="flex items-center gap-2 sm:gap-3">
                <button 
                  @click="itemConfigCantidad = Math.max(1, itemConfigCantidad - 1)"
                  class="w-8 h-8 sm:w-10 sm:h-10 bg-gray-100 dark:bg-gray-700 rounded-xl flex items-center justify-center font-black text-base sm:text-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-all"
                >
                  <Icon icon="mdi:minus" class="text-base sm:text-lg" />
                </button>
                <input 
                  v-model.number="itemConfigCantidad" 
                  type="number" 
                  step="1" 
                  min="1"
                  class="w-16 sm:w-20 px-2 sm:px-3 py-2.5 sm:py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl text-center text-base sm:text-lg font-black outline-none focus:border-green-500 transition-all [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                />
                <button 
                  @click="itemConfigCantidad = Math.min(999, itemConfigCantidad + 1)"
                  class="w-8 h-8 sm:w-10 sm:h-10 bg-gray-100 dark:bg-gray-700 rounded-xl flex items-center justify-center font-black text-base sm:text-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-all"
                >
                  <Icon icon="mdi:plus" class="text-base sm:text-lg" />
                </button>
                <div class="flex-1 text-right">
                  <p class="text-[7px] sm:text-[8px] text-gray-400 uppercase tracking-wider">TOTAL</p>
                  <p class="text-base sm:text-xl font-black text-green-600 dark:text-green-400">${{ (itemConfigPrecio * itemConfigCantidad).toFixed(2) }}</p>
                </div>
              </div>
            </div>

            <div class="bg-amber-50 dark:bg-amber-900/20 p-2.5 sm:p-3 rounded-xl border border-amber-100 dark:border-amber-800/40 flex gap-2">
              <Icon icon="mdi:information-outline" class="text-amber-500 text-sm shrink-0" />
              <p class="text-[8px] sm:text-[9px] font-bold text-amber-700 dark:text-amber-300 leading-snug">La garantía se aplica sobre el ítem completo. El precio final se multiplica por la cantidad seleccionada.</p>
            </div>
          </div>
          
          <div class="p-3 sm:p-4 md:p-5 bg-white dark:bg-gray-800 border-t border-gray-100 dark:border-gray-700">
            <button 
              @click="agregarItemConConfiguracion" 
              class="w-full py-3 sm:py-3.5 rounded-xl transition-all flex items-center justify-center gap-2 font-black text-xs sm:text-sm uppercase tracking-wider shadow-lg active:scale-95"
              :class="itemConfigTipo === 'servicio' ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white' : 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white'"
            >
              <Icon icon="mdi:check-circle" class="text-base sm:text-lg" />
              AGREGAR AL CARRITO
            </button>
            <button @click="closeItemConfigModal" class="w-full mt-2 py-2 text-[9px] sm:text-[10px] font-black text-gray-400 hover:text-gray-600 uppercase tracking-widest transition-all">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- MODAL DE SELECCIÓN DE ÍTEM DEL CATÁLOGO - RESPONSIVE CORREGIDO -->
    <Teleport to="body">
      <div v-if="showCatalogModal" class="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-2 sm:p-4 md:p-6" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="showCatalogModal = false"></div>

        <div class="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl mx-auto max-h-[92vh] flex flex-col overflow-hidden transform transition-all scale-100 animate-fadeIn">
          <div class="p-3 sm:p-4 md:p-6 border-b border-gray-200 dark:border-gray-700">
            <div class="flex justify-between items-center">
              <h3 class="text-base sm:text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                <div class="p-1.5 sm:p-2 rounded-lg" :class="catalogType === 'servicio' ? 'bg-green-100 dark:bg-green-900/30 text-green-600' : 'bg-blue-100 dark:bg-blue-900/30 text-blue-600'">
                  <Icon :icon="catalogType === 'servicio' ? 'mdi:wrench' : 'mdi:package-variant'" class="text-lg sm:text-xl" />
                </div>
                <span class="text-sm sm:text-base">Seleccionar {{ catalogType === 'servicio' ? 'Servicio' : 'Producto' }}</span>
              </h3>
              <button @click="showCatalogModal = false" class="p-1.5 sm:p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl">
                <Icon icon="mdi:close" class="text-xl sm:text-2xl text-gray-500 dark:text-gray-400" />
              </button>
            </div>
            <div class="mt-3 sm:mt-4">
              <div class="relative">
                <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input v-model="catalogSearch" type="text" placeholder="Buscar por nombre..." class="w-full pl-9 sm:pl-10 pr-3 sm:pr-4 py-2 sm:py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 font-medium outline-none text-sm" autocomplete="off" />
              </div>
            </div>
          </div>
          
          <div class="p-3 sm:p-4 md:p-6 overflow-y-auto flex-1 custom-scrollbar">
            <div v-if="filteredCatalogItems.length > 0" class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div v-for="item in filteredCatalogItems" :key="item.id" @click="seleccionarItemCatalogo(item)" class="p-3 sm:p-4 border border-gray-200 dark:border-gray-700 rounded-xl cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-[1.02] bg-white dark:bg-gray-800" :class="catalogType === 'servicio' ? 'hover:border-green-500' : 'hover:border-blue-500'">
                <div class="flex gap-2 sm:gap-3">
                  <div class="p-2 sm:p-3 rounded-lg h-fit" :class="catalogType === 'servicio' ? 'bg-green-100 dark:bg-green-900/30' : 'bg-blue-100 dark:bg-blue-900/30'">
                    <Icon :icon="catalogType === 'servicio' ? 'mdi:wrench' : 'mdi:package'" class="text-xl sm:text-2xl" :class="catalogType === 'servicio' ? 'text-green-600 dark:text-green-400' : 'text-blue-600 dark:text-blue-400'" />
                  </div>
                  <div class="flex-1 min-w-0">
                    <h4 class="font-semibold text-gray-900 dark:text-white text-sm sm:text-base truncate">{{ item.nombre }}</h4>
                    <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ catalogType === 'servicio' ? 'Servicio Técnico' : 'Producto' }}</p>
                    
                    <div class="mt-2 sm:mt-3 flex flex-wrap justify-between items-center gap-1">
                      <span class="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Precio USD:</span>
                      <span class="text-base sm:text-lg font-bold" :class="catalogType === 'servicio' ? 'text-green-600 dark:text-green-400' : 'text-blue-600 dark:text-blue-400'">${{ (catalogType === 'servicio' ? (item.precioUsd || 0) : (item.precio_venta_usd || 0)).toFixed(2) }}</span>
                    </div>
                    <div v-if="(catalogType === 'servicio' && item.garantiaDias) || (catalogType === 'producto' && item.garantia_meses)" class="mt-1 sm:mt-2">
                      <span class="text-[8px] sm:text-[9px] font-black bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 px-1.5 sm:px-2 py-0.5 rounded-full inline-block">
                        🛡️ Garantía: {{ catalogType === 'servicio' ? formatearGarantia(item.garantiaDias) : formatearGarantia((item.garantia_meses || 0) * 30) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-8 sm:py-12">
              <Icon icon="mdi:magnify-close" class="text-4xl sm:text-5xl text-gray-400 mx-auto mb-3" />
              <p class="text-gray-600 dark:text-gray-400 text-sm sm:text-base">No se encontraron resultados</p>
            </div>
          </div>
          
          <div class="p-3 sm:p-4 md:p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
            <div class="flex flex-wrap justify-between items-center gap-2">
              <p class="text-xs sm:text-sm text-gray-600 dark:text-gray-400">Seleccione un elemento para configurarlo</p>
              <button @click="showCatalogModal = false" class="px-4 sm:px-6 py-2 sm:py-2.5 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-xl hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200 font-medium text-xs sm:text-sm">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- MODAL DE WHATSAPP - RESPONSIVE CORREGIDO -->
    <Teleport to="body">
      <div v-if="showWhatsappModal" class="fixed inset-0 z-[60] overflow-y-auto flex items-center justify-center p-2 sm:p-4 md:p-6" role="dialog">
        <div class="absolute inset-0 bg-black/70 backdrop-blur-md" @click="cerrarModalWhatsapp"></div>

        <div class="relative bg-white dark:bg-gray-800 rounded-3xl shadow-2xl w-full max-w-lg mx-auto max-h-[94vh] flex flex-col overflow-y-auto transform transition-all scale-100 animate-fadeIn border border-green-500/30 custom-scrollbar">
          <div class="p-4 sm:p-6 bg-gradient-to-br from-green-600 to-emerald-700 text-white relative">
            <div class="absolute top-0 right-0 p-8 bg-white/10 rounded-full -mr-12 -mt-12 blur-3xl"></div>
            <div class="relative z-10">
              <div class="flex justify-between items-center mb-3 sm:mb-4">
                <div class="flex items-center gap-2 sm:gap-3">
                  <div class="p-2 sm:p-3 bg-white/20 rounded-2xl backdrop-blur-md">
                    <Icon icon="mdi:whatsapp" class="text-2xl sm:text-3xl text-white" />
                  </div>
                  <div>
                    <h3 class="text-base sm:text-xl font-black uppercase tracking-tighter">Notificar Cliente</h3>
                    <!-- ✅ NOMBRE DE LA EMPRESA LOGUEADA -->
                    <p class="text-[8px] sm:text-[10px] font-bold text-green-100 uppercase tracking-widest opacity-80">
                      {{ datosEmpresa?.nombreComercial || datosEmpresa?.nombre || 'Comunicación Post-Reparación' }}
                    </p>
                  </div>
                </div>
                <button @click="cerrarModalWhatsapp" class="p-1.5 sm:p-2 hover:bg-white/10 rounded-xl transition-all">
                  <Icon icon="mdi:close" class="text-xl sm:text-2xl text-white" />
                </button>
              </div>
              
              <div class="flex flex-wrap items-center gap-3 sm:gap-4 bg-black/10 p-2 sm:p-3 rounded-2xl border border-white/10">
                <div class="flex-1 min-w-[120px]">
                  <p class="text-[7px] sm:text-[8px] font-black text-green-200 uppercase mb-0.5">Cliente</p>
                  <p class="font-bold truncate text-xs sm:text-sm">{{ orden?.nombreCliente }}</p>
                </div>
                <div class="text-right">
                  <p class="text-[7px] sm:text-[8px] font-black text-green-200 uppercase mb-0.5">Orden #</p>
                  <p class="font-mono font-black text-base sm:text-lg leading-none">#{{ orden?.numeroOrden }}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="p-4 sm:p-6 space-y-4 sm:space-y-5 bg-gray-50/50 dark:bg-gray-900/50">
            <div>
              <label class="block text-[9px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1.5 sm:mb-2 px-1">Vista Previa del Mensaje</label>
              <div class="bg-white dark:bg-gray-800 p-3 sm:p-4 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm max-h-40 sm:max-h-48 overflow-y-auto custom-scrollbar">
                <p class="text-[10px] sm:text-[11px] font-medium text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-wrap break-words">
                  {{ whatsappFullMessage }}
                </p>
              </div>
            </div>

            <div>
              <label class="block text-[9px] sm:text-[10px] font-black text-green-600 dark:text-green-400 uppercase tracking-widest mb-1.5 sm:mb-2 px-1">Notas Adicionales (Opcional)</label>
              <textarea 
                v-model="tecnicoCustomMessage" 
                rows="3 sm:rows-4" 
                placeholder="Ej: El equipo está listo para retirar, el costo final fue..." 
                class="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 dark:border-gray-700 rounded-2xl bg-white dark:bg-gray-800 text-xs sm:text-sm font-medium outline-none focus:border-green-500 dark:focus:border-green-600 transition-all shadow-inner resize-none"
              ></textarea>
            </div>

            <div class="bg-amber-50 dark:bg-amber-900/20 p-2.5 sm:p-3 rounded-xl border border-amber-100 dark:border-amber-800/40 flex gap-2 sm:gap-3">
              <Icon icon="mdi:information-outline" class="text-amber-500 shrink-0 text-base sm:text-lg" />
              <p class="text-[9px] sm:text-[10px] font-bold text-amber-700 dark:text-amber-300 leading-snug">Se abrirá una nueva pestaña con WhatsApp Web o la aplicación de escritorio para enviar el mensaje.</p>
            </div>
          </div>
          
          <div class="p-4 sm:p-6 pt-0 bg-gray-50/50 dark:bg-gray-900/50">
            <button @click="enviarMensajeWhatsapp" class="w-full py-3.5 sm:py-4 bg-green-500 hover:bg-green-600 text-white rounded-2xl shadow-lg shadow-green-500/30 transition-all active:scale-95 flex items-center justify-center gap-2 sm:gap-3 font-black uppercase tracking-widest text-xs sm:text-sm">
              <Icon icon="mdi:whatsapp" class="text-xl sm:text-2xl" />
              Enviar Notificación
            </button>
            <button @click="cerrarModalWhatsapp" class="w-full mt-2 sm:mt-3 py-1.5 sm:py-2 text-[9px] sm:text-[10px] font-black text-gray-400 hover:text-gray-600 uppercase tracking-widest transition-all">
              Omitir y volver al listado
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>

import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import api from '@/api/recepcionEquipo.js';
import { obtenerServicios } from '@/api/servicios.js';
import { obtenerProductos } from '@/api/productos.js';
import { obtenerEstadosRecepcion } from '@/api/estadoRecepcion.js';
import { obtenerTecnicos, obtenerTecnicoPorIdUsuario } from '@/api/tecnicos.js';
import { getCurrentUser } from "@/utils/permissionUtils";
import { obtenerTasasVenta } from '@/api/tasaVenta.js';
import { obtenerClientePorId } from '@/api/clientes.js';
import { imprimirTicket } from '@/utils/ticketGenerator.js';
// ✅ IMPORT NUEVO: datos de la empresa logueada
import { obtenerDatosEmpresa } from '@/utils/tenantConfig.js';

export default {
  name: 'SeguimientoOrdenProceso', 
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      pasoActual: 2,
      loadingGlobal: true,
      guardando: false,
      orden: null,
      clienteFull: null,
      
      estados: [],
      tecnicos: [],
      catServicios: [],
      catProductos: [],
      tasaVirtual: 1,

      form: {
        idEstadoRecepcion: 0,
        nombreEstado: '',
        fechaHora: (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`; })(),
        fechaEntrega: (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`; })(),
        fechaPago: (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}T${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`; })(),
        idTecnico: 0,
        problemaEncontrado: '',
        actividadesRealizadas: '',
        tipoServicio: 'servicio',
        idItemLocal: 0, 
        precioUnitarioUsd: 0,
        garantiaDias: 0,
        comisionTecnicoUsd: 0,
        costoUnitarioUsd: 0,
        repuestos: '',
        nombreRepuestoManual: '',
        precioRepuestoManual: 0
      },
      
      itemsAgregados: [],
      itemsRepuestosManuales: [],
      
      showItemConfigModal: false,
      itemConfigTipo: 'servicio',
      itemConfigSeleccionado: null,
      itemConfigPrecio: 0,
      itemConfigGarantia: 0,
      itemConfigCantidad: 1,
      
      showCatalogModal: false,
      catalogType: 'servicio',
      catalogSearch: '',

      tipoVenta: 'CONTADO',
      tipoCredito: 'cacheas',
      cuotas: {
        inicial: 0,
        lista: [],
        fechaInicio: (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })(),
        inicialPersonalizada: 0
      },
      creditoEmpresa: {
        fechaPagoAcordada: (() => { const d = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })(),
        observaciones: '',
        abonoInicial: 0,
        idMetodoPagoAbono: 0,
        referenciaAbono: ''
      },

      formPago: {
        idMetodoPago: 0,
        idMetodoPagoInicial: 0,
        referencia: '',
        referenciaInicial: '',
        tecnicoEntrega: 0,
        idEstadoSalida: 0,
        idTasaVenta: 0,
        descuento: 0
      },
      pagoMovil: { banco_destino: '', cedula: '', telefono: '', banco_origen: '', referencia: '' },
      pagoInicialMovil: { banco_destino: '', cedula: '', telefono: '', banco_origen: '', referencia: '' },
      puntoVenta: { referencia: '' },
      transferencia: { banco_destino: '', banco_origen: '', referencia: '', numero_cuenta: '' },
      pagoInicialTransferencia: { banco_destino: '', banco_origen: '', referencia: '', numero_cuenta: '' },
      metodosPago: [],
      itemsEntrega: [],
      buscarItemEntrega: '',

      bancosVenezuela: ['Banco de Venezuela', 'Banesco', 'Mercantil Banco', 'Banco Provincial', 'Banco Occidental de Descuento (BOD)', 'Banco Nacional de Crédito (BNC)', 'Banco Exterior', 'Banco del Tesoro', 'Banco Bicentenario', 'Banco Venezolano de Crédito', 'Banco Sofitasa', 'Banco Caroní', 'Bancaribe', 'Banco Activo', 'Banplus', '100% Banco', 'Banco Plaza', 'Banco de la Fuerza Armada (BANFANB)', 'Mi Banco', 'Banco Agrícola de Venezuela'],
      bancosEmpresa: [
        { id: 1, nombre: 'Mercantil Banco', codigo: '0105', cuenta: '0105-0123-45-12345678', titular: 'SYSTEM JJ', cedula_titular: 'V-18.759.281', telefono: '0416-759.47.23' }, 
        { id: 2, nombre: 'Banco de Venezuela', codigo: '0102', cuenta: '0102-0123-45-12345678', titular: 'SYSTEM JJ', cedula_titular: 'V-18.759.281', telefono: '0416-759.47.23' }, 
        { id: 3, nombre: 'Banesco', codigo: '0134', cuenta: '0134-0123-45-12345678', titular: 'SYSTEM JJ', cedula_titular: 'V-18.759.281', telefono: '0416-759.47.23' }, 
        { id: 4, nombre: 'Banco Nacional de Crédito (BNC)', codigo: '0191', cuenta: '0191-0123-45-12345678', titular: 'SYSTEM JJ C.A', cedula_titular: 'J-410231190', telefono: '0412-0552022' }, 
        { id: 5, nombre: 'Banca Amiga', codigo: '0172', cuenta: '0172-0123-45-12345678', titular: 'SYSTEM JJ C.A', cedula_titular: 'J-410231190', telefono: '0412-0552022' }
      ],
      
      tasasVenta: [],
      monto_final_cacheas_diagnostico: 0,
      total_con_recargo_cacheas: 0,

      showWhatsappModal: false,
      tecnicoCustomMessage: ''
    };
  },
  async mounted() {
    this.pasoActual = parseInt(this.$route.query.tab) || 2;
    await this.cargarDependenciasYOrden();
  },
  computed: {
    // ✅ COMPUTED NUEVA: datos de la empresa logueada (tenant)
    datosEmpresa() {
      return obtenerDatosEmpresa();
    },
    filteredCatalogItems() {
      const termino = this.catalogSearch.toLowerCase().trim();
      let items = [];
      if (this.catalogType === 'servicio') {
        items = this.catServicios.map(s => ({ ...s, id: s.idServicio, precio: s.precioUsd, garantiaDias: s.garantiaDias || 0 }));
      } else {
        items = this.catProductos.map(p => ({ ...p, id: p.idProducto, precio: p.precio_venta_usd, garantiaMeses: p.garantia_meses || 0 }));
      }
      if (!termino) return items.slice(0, 50);
      return items.filter(x => (x.nombre || '').toLowerCase().includes(termino)).slice(0, 50);
    },
    
    totalServiciosF2() {
      const deLista = this.itemsAgregados.filter(it => !it.registrado).reduce((sum, it) => sum + (parseFloat(it.precio_total) || 0), 0);
      return deLista;
    },
    totalRepuestosF2() {
      const deLista = this.itemsRepuestosManuales.filter(it => !it.registrado).reduce((sum, it) => sum + (parseFloat(it.precio) || 0), 0);
      return deLista;
    },
    totalVisibleFase2() {
      const servs = this.itemsAgregados.reduce((sum, it) => sum + (parseFloat(it.precio_total) || 0), 0);
      const reps = this.itemsRepuestosManuales.reduce((sum, it) => sum + (parseFloat(it.precio) || 0), 0);
      return servs + reps;
    },
    totalFase2() { 
      return parseFloat(this.totalServiciosF2) + parseFloat(this.totalRepuestosF2);
    },
    totalContadoFase2() {
      return (this.totalVisibleFase2 || 0) + (parseFloat(this.orden?.montoDiagnostico) || 0);
    },
    totalCacheasFase2() {
      return this.redondear(this.totalContadoFase2 * 1.17);
    },
    todosLosItems() {
       return [...this.itemsAgregados, ...this.itemsRepuestosManuales, ...this.itemsEntrega];
    },
    puedeFinalizarFase2() {
      if (this.esEstadoSinCargos) {
        return (
          this.form.idEstadoRecepcion !== 0 &&
          this.form.idTecnico !== 0
        );
      }

      const tieneCargos = this.itemsAgregados.length > 0 || 
                         this.itemsRepuestosManuales.length > 0 || 
                         (parseFloat(this.form.precioRepuestoManual) > 0 && this.form.nombreRepuestoManual);
      
      return (
        this.form.idEstadoRecepcion !== 0 &&
        this.form.idTecnico !== 0 &&
        this.form.problemaEncontrado?.trim().length > 0 &&
        this.form.actividadesRealizadas?.trim().length > 0 &&
        tieneCargos
      );
    },
    totalFase3() { return this.itemsEntrega.reduce((sum, it) => sum + (it.precio_total || 0), 0); },
    
    subtotalOriginal() { 
      const diagnostico = parseFloat(this.orden?.montoDiagnostico || 0);
      const itemsSum = this.todosLosItems.reduce((sum, it) => sum + (parseFloat(it.precio_total || it.precio || 0) || 0), 0);
      return diagnostico + itemsSum;
    },
    recargoTotal() {
      if (this.tipoVenta === 'CREDITO' && this.tipoCredito === 'cacheas') {
        const totalConRecargo = this.totalConRecargo;
        return Math.max(0, totalConRecargo - this.subtotalOriginal);
      }
      return 0;
    },
    totalConRecargo() { 
       if (this.tipoVenta === 'CREDITO' && this.tipoCredito === 'cacheas') {
          return parseFloat(this.total_con_recargo_cacheas) || 0;
       }
       return this.subtotalOriginal; 
    },
    totalGeneralPagar() { 
      const total = this.totalConRecargo;
      const desc = parseFloat(this.formPago.descuento) || 0;
      const abonoPrevio = parseFloat(this.orden?.montoPagadoUsd || this.orden?.MontoPagadoUsd || 0);
      return Math.max(0, total - desc - abonoPrevio);
    },
    puedeFinalizarFase3() {
      if (this.esEntregado || this.esGarantia) return false;
      const tecnicoValido = this.formPago.tecnicoEntrega !== 0;
      if (!tecnicoValido) return false;

      if (this.tipoVenta === 'CREDITO') {
        if (this.tipoCredito === 'cacheas') {
           const montoValido = this.cuotas.inicial > 0;
           const metodoValido = this.formPago.idMetodoPagoInicial !== 0;
           if (!montoValido || !metodoValido) return false;

           if (this.esPagoMovilInicial || this.esTransferenciaInicial) {
              if (!this.formPago.referenciaInicial?.trim()) return false;
           }
           if (this.esPuntoVentaInicial) {
              if (!/^\d{4}$/.test(this.formPago.referenciaInicial)) return false;
           }
           return true;
        } else {
           if (this.creditoEmpresa.abonoInicial > 0) {
              if (this.creditoEmpresa.idMetodoPagoAbono === 0) return false;
              if (this.esAbonoEmpresaPuntoVenta) {
                 if (!/^\d{4}$/.test(this.creditoEmpresa.referenciaAbono)) return false;
              } else if (this.esAbonoEmpresaMovilOTransferencia) {
                 if (!this.creditoEmpresa.referenciaAbono?.trim()) return false;
              }
           }
           return true;
        }
      }

      const metodoValido = this.formPago.idMetodoPago !== 0;
      if (!metodoValido) return false;

      // ✅ PAGO MÓVIL: ya NO exige banco_destino
      if (this.esPagoMovil) {
        return (
          this.pagoMovil.cedula?.trim().length > 0 &&
          this.pagoMovil.telefono?.trim().length > 0 &&
          this.formPago.referencia?.trim().length > 0
        );
      }
      
      if (this.esEfectivo) return true;
      
      if (this.esPuntoVenta) {
        return /^\d{4}$/.test(this.puntoVenta.referencia);
      }
      
      return this.formPago.referencia?.trim().length > 0;
    },
    
    esPuntoVenta() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPago);
      return m?.tipo === 'punto_venta' || m?.nombre?.toLowerCase().includes('punto');
    },
    esPagoMovil() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPago);
      return m?.tipo === 'pago_movil';
    },
    esTransferencia() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPago);
      return m?.tipo === 'transferencia';
    },
    esPuntoVentaInicial() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPagoInicial);
      return m?.tipo === 'punto_venta' || m?.nombre?.toLowerCase().includes('punto');
    },
    esPagoMovilInicial() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPagoInicial);
      return m?.tipo === 'pago_movil';
    },
    esTransferenciaInicial() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPagoInicial);
      return m?.tipo === 'transferencia';
    },
    esEfectivoInicial() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPagoInicial);
      return m?.tipo === 'efectivo' || !m;
    },
    esEfectivo() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.formPago.idMetodoPago);
      return m?.tipo === 'efectivo' || !m;
    },
    referenciaPuntoVenta() {
      if (!this.puntoVenta.referencia) return '';
      return this.puntoVenta.referencia;
    },
    esAbonoEmpresaPuntoVenta() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.creditoEmpresa.idMetodoPagoAbono);
      return m?.tipo === 'punto_venta' || m?.nombre?.toLowerCase().includes('punto');
    },
    esAbonoEmpresaMovilOTransferencia() {
      const m = this.metodosPago.find(x => x.idMetodoPago == this.creditoEmpresa.idMetodoPagoAbono);
      return m?.tipo === 'pago_movil' || m?.tipo === 'transferencia';
    },
    bancoDestinoSeleccionado() {
       return this.bancosEmpresa.find(b => b.nombre === this.pagoMovil.banco_destino || b.nombre === this.transferencia.banco_destino);
    },
    esEntregado() {
       const estEnt = this.estados.find(x => x.nombre.toLowerCase().includes('entregado'));
       return this.orden?.idEstadoRecepcion && estEnt?.idEstadoRecepcion && (parseInt(this.orden.idEstadoRecepcion) === parseInt(estEnt.idEstadoRecepcion));
    },
    esGarantia() {
       const estGar = this.estados.find(x => x.nombre.toLowerCase().includes('garantia') || x.nombre.toLowerCase().includes('garantía'));
       return this.orden?.idEstadoRecepcion && estGar?.idEstadoRecepcion && (parseInt(this.orden.idEstadoRecepcion) === parseInt(estGar.idEstadoRecepcion));
    },
    estadosDisponibles() {
      if (!this.estados) return [];
      
      if (this.esEntregado) {
        return this.estados.filter(e => 
          e.nombre.toLowerCase().includes('garantia') || 
          e.nombre.toLowerCase().includes('garantía')
        );
      }
      
      if (this.esGarantia) {
        return this.estados.filter(e => 
          e.nombre.toLowerCase().includes('garantia') || 
          e.nombre.toLowerCase().includes('garantía')
        );
      }

      return this.estados.filter(e => 
        !e.nombre.toUpperCase().includes('POR DIAGNOSTICAR') &&
        !e.nombre.toUpperCase().includes('ENTREGADO')
      );
    },
    esEstadoInalterable() {
      return this.esGarantia;
    },
    esImposibleReparar() {
      if (!this.estados || !this.form.idEstadoRecepcion) return false;
      const estado = this.estados.find(e => e.idEstadoRecepcion === this.form.idEstadoRecepcion);
      return estado && estado.nombre?.toLowerCase().includes('imposible');
    },
    esEstadoSinCargos() {
      if (!this.estados || !this.form.idEstadoRecepcion) return false;
      const estado = this.estados.find(e => e.idEstadoRecepcion === this.form.idEstadoRecepcion);
      if (!estado) return false;
      const nombre = estado.nombre?.toLowerCase() || '';
      return !nombre.includes('reparado') && !nombre.includes('listo');
    },
    whatsappFullMessage() {
      const greeting = this.getGreeting();
      const clientName = this.orden?.nombreCliente || 'Cliente';
      const orderNum = this.orden?.numeroOrden || '';
      const product = this.orden?.descripcion || '';
      
      const estadoObj = this.estados.find(e => e.idEstadoRecepcion === this.form.idEstadoRecepcion);
      const estadoNombre = estadoObj?.nombre || 'Pendiente';
      
      let statusMsg = `${estadoNombre}`;
      if (estadoNombre.toLowerCase().includes('reparado') || estadoNombre.toLowerCase().includes('listo')) {
        statusMsg = `Su equipo ya está REPARADO`;
      } else if (estadoNombre.toLowerCase().includes('imposible')) {
        statusMsg = `Sin reparación posible`;
      }

      const diagnostico = this.form.problemaEncontrado || 'N/A';
      const observacion = this.form.actividadesRealizadas || 'N/A';
      
      const items = [...this.itemsAgregados, ...this.itemsRepuestosManuales];
      const serviciosTxt = items.length > 0 
        ? items.map(it => {
            const cantidad = it.cantidad || 1;
            const totalPrecio = it.precio_total || it.precio || 0;
            return `* ${it.nombre}${cantidad > 1 ? ` x${cantidad}` : ''} ($${totalPrecio.toFixed(2)})`;
          }).join('\n')
        : 'N/A';
        
      const totalContado = this.totalContadoFase2;
      const totalCacheas = this.totalCacheasFase2;
      
      // ✅ USAR NOMBRE DE LA EMPRESA LOGUEADA
      const empresa = this.datosEmpresa;
      const nombreEmpresa = empresa?.nombreComercial || empresa?.nombre || 'la empresa';

      let msg = `${greeting}, le escribimos de *${nombreEmpresa}*\n\n`;
      msg += `*ORDEN:* #${orderNum}\n`;
      msg += `*CLIENTE:* ${clientName}\n`;
      msg += `*EQUIPO:* ${product}\n\n`;
      msg += `*ESTATUS:* ${statusMsg}\n\n`;
      msg += `*DIAGNÓSTICO:*\n${diagnostico}\n\n`;
      msg += `*OBSERVACIÓN TÉCNICA:*\n${observacion}\n\n`;
      msg += `*DETALLE:*\n${serviciosTxt}\n\n`;
      msg += `*OPCIONES DE PAGO:*\n`;
      msg += `💵 Contado: *$${totalContado.toFixed(2)}*\n`;
      msg += `💳 Crédito Cachéas: *$${totalCacheas.toFixed(2)}*\n\n`;
      
      if (this.tecnicoCustomMessage) {
        msg += `*NOTA ADICIONAL:*\n${this.tecnicoCustomMessage}\n\n`;
      }

      // ✅ INFO DE CONTACTO DE LA EMPRESA LOGUEADA
      const lineasContacto = [];
      if (empresa?.telefono1) lineasContacto.push(`📞 ${empresa.telefono1}`);
      if (empresa?.whatsapp && empresa.whatsapp !== empresa.telefono1) lineasContacto.push(`📱 ${empresa.whatsapp}`);
      if (empresa?.direccion) lineasContacto.push(`📍 ${empresa.direccion}`);
      if (empresa?.email) lineasContacto.push(`✉️ ${empresa.email}`);

      if (lineasContacto.length > 0) {
        msg += `\n*${nombreEmpresa}*\n${lineasContacto.join('\n')}`;
      }
      
      return msg;
    }
  },
  methods: {
    formatearGarantia(dias) {
      if (!dias || dias === 0) return 'Sin garantía';
      if (dias >= 365) return `${Math.floor(dias / 365)} año${Math.floor(dias / 365) !== 1 ? 's' : ''}`;
      if (dias >= 30) return `${Math.floor(dias / 30)} mes${Math.floor(dias / 30) !== 1 ? 'es' : ''}`;
      return `${dias} día${dias !== 1 ? 's' : ''}`;
    },
    _toLocalDatetimeStr(d) {
      if (!d || isNaN(d.getTime())) d = new Date();
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const h = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${y}-${m}-${day}T${h}:${min}`;
    },
    async cargarDependenciasYOrden() {
      this.loadingGlobal = true;
      try {
        const idBuscado = this.$route.params.id;
        const [eRes, tRes, sRes, pRes, tvRes, oRes, mRes] = await Promise.all([
          obtenerEstadosRecepcion(true),
          obtenerTecnicos(),
          obtenerServicios('activos'),
          obtenerProductos('activos'),
          obtenerTasasVenta('activas'),
          api.obtenerRecepciones(),
          import('@/api/metodosPago.api.js').then(m => m.obtenerMetodosPago())
        ]);
        
        if (eRes.success) this.estados = eRes.data;
        if (tRes.success) this.tecnicos = tRes.data || [];
        if (sRes.success) this.catServicios = sRes.data;
        if (pRes.success) this.catProductos = pRes.data;
        if (tvRes.success) {
           this.tasasVenta = Array.isArray(tvRes.data) ? tvRes.data : [];
           if (this.tasasVenta.length > 0) {
              this.tasaVirtual = this.tasasVenta[0].precio_usd_bs || 1;
              this.formPago.idTasaVenta = this.tasasVenta[0].idTasaVenta;
           }
        }
        if (mRes.success) this.metodosPago = mRes.data || [];
        
        if (oRes.success && oRes.data) {
          const matched = oRes.data.find(x => x.numeroOrden === idBuscado || x.idRecepcionEquipo.toString() === idBuscado.toString());
          if (matched) {
            this.orden = matched;
            
            try {
               const relRes = await api.obtenerRecepcionConRelaciones(this.orden.idRecepcionEquipo);
               if (relRes.success && relRes.data) {
                  const data = relRes.data;
                  
                  if (data.detalles && !data.recepcionEquipoDetalles) {
                     data.recepcionEquipoDetalles = data.detalles;
                  }
                  
                  this.orden = { ...this.orden, ...data };
                  console.log('📦 Relaciones cargadas. Detalles encontrados:', this.orden.recepcionEquipoDetalles?.length ?? 0);
               }
               
               if (!this.orden.recepcionEquipoDetalles || this.orden.recepcionEquipoDetalles.length === 0) {
                  try {
                     const { apiFetch } = await import('@/api/index.js');
                     const detallesRes = await apiFetch(`/RecepcionEquipo/${this.orden.idRecepcionEquipo}/detalles`);
                     if (Array.isArray(detallesRes) && detallesRes.length > 0) {
                        this.orden = { ...this.orden, recepcionEquipoDetalles: detallesRes };
                        console.log('📦 Detalles cargados (fallback):', detallesRes.length);
                     }
                  } catch(e2) { console.warn('Endpoint /detalles no disponible', e2); }
               }
            } catch (e) { console.warn("No se pudieron cargar las relaciones", e); }
            
            this.configurarFormulario();
            
            if (this.orden.idCliente) {
               const cRes = await obtenerClientePorId(this.orden.idCliente);
               if (cRes.success) {
                  this.clienteFull = cRes.data;
               }
            }
          }
        }
      } catch (error) {
         console.error(error);
         this.toast.error("Error cargando dependencias.");
      } finally { this.loadingGlobal = false; }
    },
    
    configurarFormulario() {
      if (this.$route.query.tab) {
        this.pasoActual = parseInt(this.$route.query.tab);
      } 
      else if (this.$route.query.readOnly === 'true' || this.$route.query.readOnly === true) {
        this.pasoActual = 1;
      } 
      else {
        const estadoNombre = (this.orden.nombreEstado || '').toUpperCase();
        
        if (this.esEntregado || this.esGarantia) {
          this.pasoActual = 1;
        } else if (estadoNombre.includes('REPARADO') || estadoNombre.includes('LISTO') || estadoNombre.includes('REPARACIÓN FINALIZADA')) {
          this.pasoActual = 3;
        } else {
          this.pasoActual = 2;
        }
      }

      this.form.idEstadoRecepcion = this.orden.idEstadoRecepcion || 0;
      this.form.repuestos = this.orden.repuestos || '';
      this.form.fechaEntrega = this.orden.fechaEntrega ? this._toLocalDatetimeStr(new Date(this.orden.fechaEntrega)) : this._toLocalDatetimeStr(new Date());
      this.form.fechaPago = this.orden.fechaPago ? this._toLocalDatetimeStr(new Date(this.orden.fechaPago)) : this._toLocalDatetimeStr(new Date());

      const ultimo = this.extraerUltimoRegistro(this.orden.actividadesRealizadas);
      if (ultimo) {
        this.form.problemaEncontrado = ultimo.diagnostico;
        this.form.actividadesRealizadas = ultimo.solucion;
      } else {
        this.form.problemaEncontrado = '';
        this.form.actividadesRealizadas = '';
      }
      
      const uid = parseInt(localStorage.getItem('idUsuario'));
      const tLog = this.tecnicos.find(x => x.idUsuario === uid);
      
      const idRep = this.orden.idTecnicoReparador || this.orden.IdTecnicoReparador;
      if (idRep) {
         this.form.idTecnico = idRep;
         const t = this.tecnicos.find(x => (x.idTecnico || x.IdTecnico) === idRep);
         if (t) this.buscarTecnicoPaso2 = `${t.nombre || t.Nombre} ${t.apellido || t.Apellido}`;
      }

      const idEnt = this.orden.idTecnicoEntrega || this.orden.IdTecnicoEntrega;
      if (idEnt) {
         this.formPago.tecnicoEntrega = idEnt;
         const t = this.tecnicos.find(x => (x.idTecnico || x.IdTecnico) === idEnt);
         if (t) this.buscarTecnicoPaso3 = `${t.nombre || t.Nombre} ${t.apellido || t.Apellido}`;
      }

      this.asignarTecnicoActual();

      const estEnt = this.estados.find(x => 
         x.nombre.toLowerCase().includes('entregado') || 
         x.nombre.toLowerCase().includes('entrega')
      );
      if (estEnt) {
         this.formPago.idEstadoSalida = estEnt.idEstadoRecepcion;
      } else {
         console.warn("⚠️ No se encontró el estado 'ENTREGADO' por nombre. Usando ID 4 como fallback.");
         this.formPago.idEstadoSalida = 4; 
      }

      if ((this.orden.tipoDiagnostico?.toUpperCase() === 'EXPRESS' || this.orden.tipoDiagnostico?.toUpperCase() === 'EXPRESS (PRIORITARIO)') && this.orden.montoDiagnostico > 0) {
         this.formPago.descuento = this.orden.montoDiagnostico;
         console.log("💰 Descuento pre-cargado desde diagnóstico express:", this.orden.montoDiagnostico);
      }

      if (this.orden.montoDiagnostico) {
         this.monto_final_cacheas_diagnostico = this.redondear(this.orden.montoDiagnostico * 1.17);
      }

      const listaDetalles = this.orden.recepcionEquipoDetalles || this.orden.detalles || [];
      
      if (listaDetalles.length > 0) {
         this.itemsAgregados = [];
         this.itemsRepuestosManuales = [];
         
         listaDetalles.forEach(det => {
            const precio     = parseFloat(det.subtotalUsd  || det.SubtotalUsd  || det.precioUnitarioUsd || det.PrecioUnitarioUsd || 0);
            const idServicio = det.idServicio  || det.IdServicio;
            const idProducto = det.idProducto  || det.IdProducto;
            const nomServicio = det.nombreServicio || det.NombreServicio || det.servicio?.nombre || '';
            const nomProducto = det.nombreProducto || det.NombreProducto || det.producto?.nombre || '';
            const obs         = det.observaciones  || det.Observaciones  || '';
            const uuid        = (det.idRecepcionEquipoDetalle || det.IdRecepcionEquipoDetalle)?.toString() 
                                || Math.random().toString(36).substring(7);
            const cantidad = det.cantidad || 1;
            
            if (obs.startsWith('REPUESTO:')) {
               this.itemsRepuestosManuales.push({
                  uuid,
                  nombre: obs.replace(/^REPUESTO:\s*/i, '').trim(),
                  precio,
                  precio_final_cacheas: this.redondear(precio * 1.17),
                  registrado: true,
                  garantia: 0,
                  cantidad: 1
               });
            } else if (idServicio) {
               const servicioOrig = this.catServicios.find(s => s.idServicio === idServicio);
               this.itemsAgregados.push({
                  uuid, id: idServicio, tipo: 'servicio',
                  nombre: obs || nomServicio || 'Servicio Técnico',
                  precio: precio,
                  precio_unitario: precio / (cantidad || 1),
                  precio_total: precio,
                  cantidad: cantidad || 1,
                  precio_final_cacheas: this.redondear(precio * 1.17),
                  registrado: true,
                  garantia: servicioOrig?.garantiaDias || 0
               });
            } else if (idProducto) {
               const productOrig = this.catProductos.find(p => p.idProducto === idProducto);
               this.itemsAgregados.push({
                  uuid, id: idProducto, tipo: 'producto',
                  nombre: obs || nomProducto || 'Producto',
                  precio: precio,
                  precio_unitario: precio / (cantidad || 1),
                  precio_total: precio,
                  cantidad: cantidad || 1,
                  precio_final_cacheas: this.redondear(precio * 1.17),
                  registrado: true,
                  garantia: (productOrig?.garantia_meses || 0) * 30
               });
            } else if (precio > 0) {
               this.itemsAgregados.push({
                  uuid, id: null, tipo: 'servicio',
                  nombre: obs || 'Servicio Técnico',
                  precio: precio,
                  precio_unitario: precio / (cantidad || 1),
                  precio_total: precio,
                  cantidad: cantidad || 1,
                  precio_final_cacheas: this.redondear(precio * 1.17),
                  registrado: true,
                  garantia: 0
               });
            }
         });
         
         console.log('📋 Items cargados:', {
            servicios: this.itemsAgregados.length,
            repuestos: this.itemsRepuestosManuales.length
         });
         this.recalcularTotalCacheas();
         this.calcularCuotas();
      }
    },

    async asignarTecnicoActual() {
      const user = getCurrentUser();
      if (!user) return;
      
      const idUsuario = user.idUsuario || user.id;
      const res = await obtenerTecnicoPorIdUsuario(idUsuario);
      
      if (res.success && res.data) {
        const tec = res.data;
        const idTec = tec.idTecnico || tec.IdTecnico;
        const nombreTec = `${tec.nombre || tec.Nombre} ${tec.apellido || tec.Apellido}`;
        
        if (this.pasoActual === 2) {
          this.form.idTecnico = idTec;
        } else if (this.pasoActual === 3) {
          this.formPago.tecnicoEntrega = idTec;
        }
      } else {
        if (this.pasoActual === 2) {
          this.form.idTecnico = idUsuario; 
        } else if (this.pasoActual === 3) {
          this.formPago.tecnicoEntrega = idUsuario;
        }
      }
    },

    abrirModalConfiguracionItem(tipo) {
      this.itemConfigTipo = tipo;
      this.showCatalogModal = true;
      this.catalogType = tipo;
      this.catalogSearch = '';
    },
    
    seleccionarItemCatalogo(item) {
      this.itemConfigSeleccionado = item;
      if (this.itemConfigTipo === 'servicio') {
        this.itemConfigPrecio = item.precioUsd || 0;
        this.itemConfigGarantia = item.garantiaDias || 0;
      } else {
        this.itemConfigPrecio = item.precio_venta_usd || 0;
        this.itemConfigGarantia = (item.garantia_meses || 0) * 30;
      }
      this.itemConfigCantidad = 1;
      this.showCatalogModal = false;
      this.showItemConfigModal = true;
    },
    
    agregarItemConConfiguracion() {
      if (!this.itemConfigSeleccionado) return;
      if (this.itemConfigPrecio <= 0) {
        this.toast.warning("El precio debe ser mayor a cero");
        return;
      }
      if (this.itemConfigCantidad < 1) {
        this.toast.warning("La cantidad debe ser al menos 1");
        return;
      }
      
      const precioTotal = this.itemConfigPrecio * this.itemConfigCantidad;
      const nuevoItem = {
        uuid: Math.random().toString(36).substring(7),
        id: this.itemConfigSeleccionado.id,
        tipo: this.itemConfigTipo,
        nombre: this.itemConfigSeleccionado.nombre,
        precio_unitario: this.itemConfigPrecio,
        precio_total: precioTotal,
        precio: precioTotal,
        cantidad: this.itemConfigCantidad,
        garantia: this.itemConfigGarantia,
        precio_final_cacheas: this.redondear(precioTotal * 1.17),
        costo: this.itemConfigTipo === 'servicio' 
          ? (this.itemConfigSeleccionado.costoManoObraUsd || 0) 
          : (this.itemConfigSeleccionado.precio_compra_usd || 0),
        comision: this.itemConfigSeleccionado.comisionTecnico || 0,
        registrado: false
      };
      
      this.itemsAgregados.push(nuevoItem);
      
      if (this.itemConfigGarantia > 0) {
        this.toast.success(`✅ Garantía de ${this.formatearGarantia(this.itemConfigGarantia)} aplicada al ${this.itemConfigTipo === 'servicio' ? 'servicio' : 'producto'} "${this.itemConfigSeleccionado.nombre}"`);
      }
      
      this.closeItemConfigModal();
      this.recalcularTotalCacheas();
      this.calcularCuotas();
    },
    
    abrirModalConfiguracionItemFase3(tipo) {
      this.itemConfigTipo = tipo;
      this.showCatalogModal = true;
      this.catalogType = tipo;
      this.catalogSearch = '';
      this.itemConfigFase3 = true;
    },
    
    agregarItemFase3ConConfiguracion() {
      if (!this.itemConfigSeleccionado) return;
      if (this.itemConfigPrecio <= 0) {
        this.toast.warning("El precio debe ser mayor a cero");
        return;
      }
      if (this.itemConfigCantidad < 1) {
        this.toast.warning("La cantidad debe ser al menos 1");
        return;
      }
      
      const precioTotal = this.itemConfigPrecio * this.itemConfigCantidad;
      const nuevoItem = {
        uuid: Math.random().toString(36).substring(7),
        id: this.itemConfigSeleccionado.id,
        tipo: this.itemConfigTipo,
        nombre: this.itemConfigSeleccionado.nombre,
        precio_unitario: this.itemConfigPrecio,
        precio_total: precioTotal,
        precio: precioTotal,
        cantidad: this.itemConfigCantidad,
        garantia: this.itemConfigGarantia,
        precio_final_cacheas: this.redondear(precioTotal * 1.17),
        costo: this.itemConfigTipo === 'servicio' 
          ? (this.itemConfigSeleccionado.costoManoObraUsd || 0) 
          : (this.itemConfigSeleccionado.precio_compra_usd || 0),
        comision: this.itemConfigSeleccionado.comisionTecnico || 0,
        registrado: false
      };
      
      this.itemsEntrega.push(nuevoItem);
      
      if (this.itemConfigGarantia > 0) {
        this.toast.success(`✅ Garantía de ${this.formatearGarantia(this.itemConfigGarantia)} aplicada al producto "${this.itemConfigSeleccionado.nombre}"`);
      }
      
      this.closeItemConfigModal();
      this.recalcularTotalCacheas();
      this.calcularCuotas();
    },
    
    closeItemConfigModal() {
      this.showItemConfigModal = false;
      this.itemConfigSeleccionado = null;
      this.itemConfigPrecio = 0;
      this.itemConfigGarantia = 0;
      this.itemConfigCantidad = 1;
      this.itemConfigFase3 = false;
    },
    
    actualizarDesdePrecioTotal(item) {
      if (item.cantidad > 0 && item.precio_total > 0) {
        const nuevoUnitario = item.precio_total / item.cantidad;
        item.precio_unitario = nuevoUnitario;
        item.precio = item.precio_total;
        item.precio_final_cacheas = this.redondear(item.precio_total * 1.17);
      }
      this.recalcularTotalCacheas();
      this.calcularCuotas();
    },
    
    actualizarDesdePrecioTotalFase3(item) {
      if (item.cantidad > 0 && item.precio_total > 0) {
        const nuevoUnitario = item.precio_total / item.cantidad;
        item.precio_unitario = nuevoUnitario;
        item.precio = item.precio_total;
        item.precio_final_cacheas = this.redondear(item.precio_total * 1.17);
      }
      this.recalcularTotalCacheas();
      this.calcularCuotas();
    },

    eliminarItemCarrito(uuid) {
      this.itemsAgregados = this.itemsAgregados.filter(it => it.uuid !== uuid);
      this.recalcularTotalCacheas();
      this.calcularCuotas();
    },

    onMetodoPagoInicialChange() {
       this.pagoInicialMovil = { banco_destino: '', cedula: '', telefono: '', banco_origen: '', referencia: '' };
       this.pagoInicialTransferencia = { banco_destino: '', banco_origen: '', referencia: '', numero_cuenta: '' };
       this.formPago.referenciaInicial = '';
    },

    actualizarInicial() {
       this.cuotas.inicial = parseFloat(this.cuotas.inicialPersonalizada) || 0;
       this.calcularCuotas();
    },

    calcularCuotas() {
       const totalFinanciar = this.totalConRecargo - this.cuotas.inicial;
       const montoCuota = totalFinanciar / 3;
       const lista = [];
       let fechaStr = this.cuotas.fechaInicio;
       if (!fechaStr.includes('T')) fechaStr += 'T12:00:00Z';
       let fecha = new Date(fechaStr);

       for (let i = 0; i < 3; i++) {
          fecha.setUTCDate(fecha.getUTCDate() + 7);
          lista.push({
             numero: i + 1,
             fechaPago: fecha.toISOString().slice(0, 10),
             montoUsd: Number(montoCuota.toFixed(2)),
             montoBs: Number((montoCuota * this.tasaVirtual).toFixed(2))
          });
       }
       this.cuotas.lista = lista;
    },

    onMetodoPagoChange() {
       this.pagoMovil = { banco_destino: '', cedula: '', telefono: '', banco_origen: '', referencia: '' };
       this.puntoVenta = { ultimosDigitosCedula: '', ultimosDigitosTelefono: '' };
       this.transferencia = { banco_destino: '', banco_origen: '', referencia: '', numero_cuenta: '' };
       this.formPago.referencia = '';
    },

    calcularAbonoEmpresa() {
      const max = this.subtotalOriginal || 0;
      if (this.creditoEmpresa.abonoInicial > max) {
        this.creditoEmpresa.abonoInicial = max;
      }
      if (this.creditoEmpresa.abonoInicial <= 0) {
        this.creditoEmpresa.idMetodoPagoAbono = 0;
        this.creditoEmpresa.referenciaAbono = '';
      }
    },

    onMetodoPagoAbonoEmpresaChange() {
      this.creditoEmpresa.referenciaAbono = '';
    },

    async guardarCambiosYEstado() {
       if (!this.puedeFinalizarFase2) {
          this.toast.warning("Debe completar Responsable, Diagnóstico, Observaciones y agregar al menos un cargo (Servicio/Producto/Repuesto).");
          return;
       }

       const estadoSeleccionado = this.estados.find(e => e.idEstadoRecepcion === this.form.idEstadoRecepcion);
       if (estadoSeleccionado && estadoSeleccionado.nombre.toUpperCase().includes('POR DIAGNOSTICAR')) {
          this.toast.warning("Debe seleccionar un estado diferente a 'POR DIAGNOSTICAR' para continuar.");
          return;
       }
       
       this.guardando = true;
       try {
          const tSel = this.tasasVenta.find(x => x.idTasaVenta == this.formPago.idTasaVenta) || { precio_usd_bs: this.tasaVirtual };
          const notas = `DIAGNÓSTICO (${new Date().toLocaleString()}):\n${this.form.problemaEncontrado}\n\nSOLUCIÓN:\n${this.form.actividadesRealizadas}`;
          const historial = this.orden.actividadesRealizadas ? `${this.orden.actividadesRealizadas}\n\n=========================\n\n${notas}` : notas;
          
          const detallesPayload = [];

          this.itemsAgregados.forEach(it => {
              detallesPayload.push({
                  IdRecepcionEquipoDetalle: it.registrado ? (parseInt(it.uuid) || 0) : 0,
                  Cantidad: it.cantidad || 1,
                  PrecioUnitarioUsd: parseFloat(it.precio_unitario || it.precio || 0),
                  SubtotalUsd: parseFloat(it.precio_total || it.precio || 0),
                  PrecioUnitarioBs: (parseFloat(it.precio_unitario || it.precio || 0)) * tSel.precio_usd_bs,
                  SubtotalBs: (parseFloat(it.precio_total || it.precio || 0)) * tSel.precio_usd_bs,
                  CostoUnitarioUsd: it.costo || 0,
                  CostoTotalUsd: (it.costo || 0) * (it.cantidad || 1),
                  ComisionTecnicoUsd: it.comision || 0,
                  GarantiaDias: it.garantia || 0,
                  IdServicio: it.tipo === 'servicio' ? it.id : null,
                  IdProducto: it.tipo === 'producto' ? it.id : null,
                  IdTecnico: parseInt(this.form.idTecnico),
                  IdEstadoRecepcion: parseInt(this.form.idEstadoRecepcion),
                  Observaciones: it.nombre
              });
          });

          this.itemsRepuestosManuales.forEach(rep => {
              detallesPayload.push({
                  IdRecepcionEquipoDetalle: rep.registrado ? (parseInt(rep.uuid) || 0) : 0,
                  Cantidad: 1,
                  PrecioUnitarioUsd: parseFloat(rep.precio) || 0,
                  SubtotalUsd: parseFloat(rep.precio) || 0,
                  PrecioUnitarioBs: (parseFloat(rep.precio) || 0) * tSel.precio_usd_bs,
                  SubtotalBs: (parseFloat(rep.precio) || 0) * tSel.precio_usd_bs,
                  IdTecnico: parseInt(this.form.idTecnico),
                  IdEstadoRecepcion: parseInt(this.form.idEstadoRecepcion),
                  IdServicio: null,
                  IdProducto: null,
                  Observaciones: "REPUESTO: " + (rep.nombre || 'Manual'),
                  GarantiaDias: 0
              });
          });

          if (parseFloat(this.form.precioRepuestoManual) > 0 && this.form.nombreRepuestoManual) {
              detallesPayload.push({
                  IdRecepcionEquipoDetalle: 0,
                  Cantidad: 1,
                  PrecioUnitarioUsd: parseFloat(this.form.precioRepuestoManual),
                  SubtotalUsd: parseFloat(this.form.precioRepuestoManual),
                  PrecioUnitarioBs: parseFloat(this.form.precioRepuestoManual) * tSel.precio_usd_bs,
                  SubtotalBs: parseFloat(this.form.precioRepuestoManual) * tSel.precio_usd_bs,
                  IdTecnico: parseInt(this.form.idTecnico),
                  IdEstadoRecepcion: parseInt(this.form.idEstadoRecepcion),
                  Observaciones: "REPUESTO: " + this.form.nombreRepuestoManual,
                  GarantiaDias: 0
              });
          }

          const nuevoTotal = (this.orden.montoDiagnostico || 0) + detallesPayload.reduce((sum, d) => sum + d.SubtotalUsd, 0);

          const payloadUpdate = {
              IdRecepcionEquipo: this.orden.idRecepcionEquipo || this.orden.IdRecepcionEquipo,
              NumeroOrden: this.orden.numeroOrden || this.orden.NumeroOrden || '',
              IdCliente: this.orden.idCliente || this.orden.IdCliente,
              IdUsuario: this.orden.idUsuario || this.orden.IdUsuario,
              IdEstadoRecepcion: parseInt(this.form.idEstadoRecepcion),
              IdTecnicoAsignado: this.orden.idTecnicoAsignado || this.orden.IdTecnicoAsignado,
              IdTecnicoRecepcion: this.orden.idTecnicoRecepcion || this.orden.IdTecnicoRecepcion || this.orden.idTecnicoAsignado || this.orden.IdTecnicoAsignado,
              IdTecnicoReparador: parseInt(this.form.idTecnico),
              IdTecnicoEntrega: this.orden.idTecnicoEntrega || this.orden.IdTecnicoEntrega,
              PrecioTotalUsd: nuevoTotal || 0,
              Problema: this.orden.problema || this.orden.Problema || 'N/A',
              Descripcion: this.orden.descripcion || this.orden.Descripcion || 'N/A',
              Accesorios: this.orden.accesorios || this.orden.Accesorios || 'Ninguno',
              ActividadesRealizadas: historial,
              Repuestos: this.form.repuestos || '',
              ClavePatron: this.orden.clavePatron || this.orden.ClavePatron || '',
              Taller: this.orden.taller || this.orden.Taller || false,
              TipoDiagnostico: this.orden.tipoDiagnostico || this.orden.TipoDiagnostico || 'GRATIS',
              MontoDiagnostico: this.orden.montoDiagnostico || this.orden.MontoDiagnostico || 0,
              IdSede: this.orden.idSede || this.orden.IdSede || 1,
              IdProductoServicios: this.orden.idProductoServicios || this.orden.IdProductoServicios,
              FechaIngreso: this.orden.fechaIngreso || this.orden.FechaIngreso,
              FechaReparacion: this.form.fechaHora,
              Detalles: detallesPayload
           };

           const res = await api.actualizarRecepcion(this.orden.idRecepcionEquipo, payloadUpdate);
           if (!res.success) throw new Error(res.error || "Fallo al actualizar la orden");
          
          this.orden.precioTotalUsd = nuevoTotal;
          this.toast.success("Orden actualizada correctamente");
          
          this.showWhatsappModal = true;
       } catch (e) { 
          console.error("❌ Error en guardarCambiosYEstado:", e);
          this.toast.error("Error al guardar: " + e.message); 
       }
       finally { this.guardando = false; }
    },

    async procesarEntrega() {
        if (!this.puedeFinalizarFase3) {
           this.toast.warning("Debe completar el Técnico de Entrega, el Método de Pago y todos los datos requeridos (Referencia, etc).");
           return;
        }

        this.procesando = true;
        this.loadingGlobal = true;

        try {
           const idUsuario = parseInt(localStorage.getItem('idUsuario')) || 1;
           const tSel = this.tasasVenta.find(t => t.activa) || { idTasaVenta: 1, precio_usd_bs: this.tasaVirtual || 45, idFuenteTasa: 1 };
           
           console.log("🚀 Iniciando procesamiento técnico de entrega...");
           const mSel = this.metodosPago.find(m => m.idMetodoPago === this.formPago.idMetodoPago) || { nombre: 'EFECTIVO' };
           const mNombre = mSel.nombre;

           let ref = this.formPago.referencia;
           // ✅ PAGO MÓVIL sin banco destino
           if (this.esPagoMovil) ref = `PM-${this.formPago.referencia}`;
           if (this.esTransferencia) ref = `TR-${this.transferencia.banco_destino}-${this.formPago.referencia}`;
           if (this.esPuntoVenta) ref = this.referenciaPuntoVenta;

           let refInicial = this.formPago.referenciaInicial;
           if (this.esPagoMovilInicial) refInicial = `PM-${this.pagoInicialMovil.banco_destino}-${this.formPago.referenciaInicial}`;
           if (this.tipoCredito === 'empresa' && this.creditoEmpresa.abonoInicial > 0) {
              refInicial = this.creditoEmpresa.referenciaAbono;
           }

           const { crearCuotasSalidaEquipo } = await import('@/api/creditoSalidaEquipo.js');

           const detallesAgregados = [];
           for (const item of this.itemsEntrega) {
              const resDet = await api.crearDetalleRecepcion(this.orden.idRecepcionEquipo, {
                 Cantidad: item.cantidad || 1, 
                 PrecioUnitarioUsd: item.precio_unitario || item.precio || 0, 
                 SubtotalUsd: item.precio_total || item.precio || 0,
                 PrecioUnitarioBs: (item.precio_unitario || item.precio || 0) * tSel.precio_usd_bs, 
                 SubtotalBs: (item.precio_total || item.precio || 0) * tSel.precio_usd_bs,
                 CostoUnitarioUsd: item.costo || 0, 
                 CostoTotalUsd: (item.costo || 0) * (item.cantidad || 1), 
                 IdProducto: item.tipo === 'producto' ? item.id : null,
                 IdServicio: item.tipo === 'servicio' ? item.id : null,
                 IdTecnico: parseInt(this.formPago.tecnicoEntrega),
                 IdEstadoRecepcion: parseInt(this.formPago.idEstadoSalida),
                 IdUsuario: idUsuario,
                 Observaciones: item.nombre,
                 GarantiaDias: item.garantia || 0
              });
              detallesAgregados.push(resDet);
           }

           const idRedPrincipal = this.orden.detalles?.[0]?.idRecepcionEquipoDetalle || this.orden.idRecepcionEquipo;

           const totalGeneral = this.totalGeneralPagar;
           let montoInicial = 0;
           if (this.tipoVenta === 'CONTADO') {
              montoInicial = totalGeneral;
           } else if (this.tipoCredito === 'cacheas') {
              montoInicial = this.cuotas.inicial || 0;
           } else if (this.tipoCredito === 'empresa') {
              montoInicial = this.creditoEmpresa.abonoInicial || 0;
           }

           let metodoPagoFinal = mNombre;
           if (this.tipoVenta === 'CREDITO') {
             if (this.tipoCredito === 'cacheas') {
               metodoPagoFinal = 'CREDITO CACHEAS';
             } else if (this.tipoCredito === 'empresa') {
               metodoPagoFinal = 'CREDITO EMPRESARIAL';
             }
           }

           const montoInicialBackend = this.tipoVenta === 'CREDITO' ? 0 : montoInicial;
           const montoBsBackend = this.tipoVenta === 'CREDITO' ? 0 : (montoInicial * tSel.precio_usd_bs);

           const payloadEntrega = {
              idRecepcionEquipoDetalle: idRedPrincipal,
              IdUsuarioEntrega: parseInt(this.formPago.tecnicoEntrega), 
              IdUsuarioCajero: idUsuario,
              MetodoPago: metodoPagoFinal,
              TotalOriginal: totalGeneral, 
              MontoUsd: montoInicialBackend,
              MontoBs: montoBsBackend,
              Referencia: (this.tipoVenta === 'CREDITO' ? refInicial : ref) || 'S/R',
              TasaVenta: tSel.precio_usd_bs, 
              IdTasaVenta: tSel.idTasaVenta, 
              IdFuenteTasa: tSel.idFuenteTasa,
              idEstadoSalida: parseInt(this.formPago.idEstadoSalida), 
              Descuento: parseFloat(this.formPago.descuento) || 0,
              FechaEntrega: this.form.fechaEntrega,
              FechaPago: this.form.fechaPago,
              Observaciones: `Entrega Orden #${this.orden.numeroOrden}.` + (this.formPago.descuento > 0 ? ` Descuento aplicado: $${this.formPago.descuento}` : '')
           };

           const resEntrega = await api.registrarEntregaPago(this.orden.idRecepcionEquipo, payloadEntrega);
           if(!resEntrega.success) throw new Error(resEntrega.error);

           const idSalidaPrincipal = resEntrega.data.idSalidaEquipoDetalle;

           if (this.tipoVenta === 'CREDITO' && montoInicial > 0) {
              console.log("💰 Registrando abono inicial real de la reparación...");
              const { crearPagoSalidaEquipo } = await import('@/api/pagoSalidaEquipo.js');
              
              let metodoPagoReal = 'EFECTIVO';
              if (this.tipoCredito === 'cacheas') {
                 const mObj = this.metodosPago.find(m => m.idMetodoPago === this.formPago.idMetodoPagoInicial);
                 metodoPagoReal = mObj ? mObj.nombre : 'EFECTIVO';
              } else if (this.tipoCredito === 'empresa') {
                 const mObj = this.metodosPago.find(m => m.idMetodoPago === this.creditoEmpresa.idMetodoPagoAbono);
                 metodoPagoReal = mObj ? mObj.nombre : 'EFECTIVO';
              }

              await crearPagoSalidaEquipo({
                 idSalidaEquipoDetalle: idSalidaPrincipal,
                 numeroRecibo: `INI-${this.orden.numeroOrden || idSalidaPrincipal}`,
                 fechaPago: new Date().toISOString(),
                 montoUsd: montoInicial,
                 montoBs: +(montoInicial * tSel.precio_usd_bs).toFixed(2),
                 tasaBsUsd: tSel.precio_usd_bs,
                 idFuenteTasa: parseInt(tSel.idFuenteTasa, 10),
                 idTasaVenta: parseInt(tSel.idTasaVenta, 10),
                 tipoPago: 'Abono',
                 tipoCredito: this.tipoCredito.toUpperCase(),
                 saldoPendienteUsd: Math.max(0, totalGeneral - montoInicial),
                 saldoPendienteBs: Math.max(0, (totalGeneral - montoInicial) * tSel.precio_usd_bs),
                 metodoPago: metodoPagoReal,
                 referencia: refInicial || 'S/R',
                 idUsuario: idUsuario,
                 estado: 'Completado',
                 observaciones: `Abono inicial de ${metodoPagoReal} para Crédito ${this.tipoCredito.toUpperCase()} en Orden #${this.orden.numeroOrden}`
              });
           }

           if (this.tipoVenta === 'CREDITO') {
              let cuotasParaBackend = [];
              
              if (this.tipoCredito === 'cacheas') {
                 const fechaInicio = this.cuotas.fechaInicio || new Date().toISOString().split('T')[0];
                 
                 cuotasParaBackend = this.cuotas.lista.map((c, index) => ({
                    idSalidaEquipoDetalle: idSalidaPrincipal,
                    numeroCuota: index + 1,
                    fechaVencimiento: c.fechaPago,
                    fechaInicio: fechaInicio,
                    montoUsd: c.montoUsd,
                    montoBs: c.montoBs,
                    saldoUsd: c.montoUsd,
                    saldoBs: c.montoBs,
                    estado: "Pendiente",
                    observaciones: `Cuota Cashea por reparación #${this.orden.numeroOrden}`
                 }));
              } else if (this.tipoCredito === 'empresa') {
                 const abonoInicial = this.creditoEmpresa.abonoInicial || 0;
                 const saldoPendienteUsd = Math.max(0, this.subtotalOriginal - abonoInicial);
                 const saldoPendienteBs = saldoPendienteUsd * tSel.precio_usd_bs;
                 
                 if (saldoPendienteUsd > 0) {
                    let fechaAcordada = this.creditoEmpresa.fechaPagoAcordada;
                    if (!fechaAcordada) {
                       let hoy = new Date();
                       hoy.setDate(hoy.getDate() + 15);
                       fechaAcordada = hoy.toISOString().slice(0, 10);
                    }
                    
                    cuotasParaBackend = [{
                       idSalidaEquipoDetalle: idSalidaPrincipal,
                       numeroCuota: 1,
                       fechaVencimiento: fechaAcordada,
                       fechaInicio: new Date().toISOString().split('T')[0],
                       montoUsd: saldoPendienteUsd,
                       montoBs: saldoPendienteBs,
                       saldoUsd: saldoPendienteUsd,
                       saldoBs: saldoPendienteBs,
                       estado: "Pendiente",
                       observaciones: `Crédito Empresa #${this.orden.numeroOrden}`
                    }];
                 }
              }

              if (cuotasParaBackend.length > 0) {
                 await crearCuotasSalidaEquipo(cuotasParaBackend);
              }
           }

           this.orden.idEstadoRecepcion = this.formPago.idEstadoSalida;

            this.toast.success("Entrega técnica y crédito procesados exitosamente.");
            
            try {
              const ordenParaTicket = {
                ...this.orden,
                numeroOrden: this.orden.numeroOrden,
                nombreEstado: this.orden.nombreEstado,
                fechaEntrega: this.form.fechaEntrega || new Date().toISOString(),
                fechaPago: this.form.fechaPago || new Date().toISOString(),
                montoPagadoUsd: montoInicial,
                metodoPago: mNombre,
                referenciaPago: (this.tipoVenta === 'CREDITO' ? refInicial : ref) || 'S/R',
                descuento: this.formPago.descuento || 0,
                garantiaDias: this.calcularGarantiaTotal(),
                servicios: this.itemsAgregados.map(s => ({
                  nombre: s.nombre,
                  precio: s.precio_total || s.precio,
                  cantidad: s.cantidad || 1,
                  observaciones: s.nombre,
                  garantia: s.garantia
                })),
                productos: this.itemsEntrega.map(p => ({
                  nombre: p.nombre,
                  precio: p.precio_total || p.precio,
                  cantidad: p.cantidad || 1,
                  garantia: p.garantia
                }))
              };
              
              console.log("🖨️ Imprimiendo ticket de GARANTÍA Y REPARACIÓN con método:", mNombre);
              
              await imprimirTicket(ordenParaTicket, this.clienteFull, { nombre: this.formPago.tecnicoEntrega });
            } catch (ePrint) { 
              console.warn("Error al imprimir ticket de garantía:", ePrint); 
            }

            this.$emit('actualizado');
           setTimeout(() => this.$router.push('/recepcion-equipo-list'), 1500);

        } catch (error) {
           console.error("❌ Fallo en procesarEntrega:", error);
           this.toast.error("Error al procesar: " + error.message);
        } finally {
           this.procesando = false;
           this.loadingGlobal = false;
        }
    },

    calcularGarantiaTotal() {
      let maxGarantia = 0;
      this.itemsAgregados.forEach(item => {
        if (item.garantia && item.garantia > maxGarantia) {
          maxGarantia = item.garantia;
        }
      });
      this.itemsEntrega.forEach(item => {
        if (item.garantia && item.garantia > maxGarantia) {
          maxGarantia = item.garantia;
        }
      });
      return maxGarantia;
    },

    agregarRepuestoManual() {
      if (!this.form.nombreRepuestoManual || this.form.precioRepuestoManual <= 0) {
        this.toast.warning("Ingrese nombre y precio del repuesto.");
        return;
      }
      this.itemsRepuestosManuales.push({
        nombre: this.form.nombreRepuestoManual,
        precio: this.form.precioRepuestoManual,
        precio_final_cacheas: this.redondear(this.form.precioRepuestoManual * 1.17),
        registrado: false,
        garantia: 0,
        cantidad: 1
      });
      this.form.nombreRepuestoManual = '';
      this.form.precioRepuestoManual = 0;
      this.recalcularTotalCacheas();
      this.calcularCuotas();
    },

    parsearHistorial(texto) {
       if(!texto) return [];
       return texto.split('=========================')
          .map(t => ({ tipo: t.includes('DIAGNÓSTICO') ? 'diag' : (t.includes('PAGO') ? 'pago' : 'normal'), fecha: (t.match(/\((.*?)\)/) || [])[1] || '---', texto: t.trim() }))
          .filter(x => x.texto.length > 5);
    },
    alCambiarEstadoSelect() {
      if (this.esEstadoSinCargos) {
        const nombre = this.estados.find(e => e.idEstadoRecepcion === this.form.idEstadoRecepcion)?.nombre.toLowerCase() || '';
        if (nombre.includes('imposible')) {
           this.itemsAgregados = [];
           this.itemsRepuestosManuales = [];
           this.form.problemaEncontrado = "EQUIPO IMPOSIBLE DE REPARAR";
           this.form.actividadesRealizadas = "Se diagnosticó el equipo y se determinó que no tiene reparación factible.";
           this.toast.info("Estado 'Imposible de Reparar' detectado. Se han reseteado los cargos.");
        }
      }
    },
    extraerUltimoRegistro(texto) {
      if (!texto || (!texto.includes('=========================') && !texto.includes('DIAGNÓSTICO'))) return null;
      
      const bloques = texto.split('=========================');
      const ultimoBloque = bloques[bloques.length - 1].trim();
      
      const diagMatch = ultimoBloque.match(/DIAGNÓSTICO \(.*?\):\s*([\s\S]*?)(?=\n\nSOLUCIÓN:|$)/i);
      const solMatch = ultimoBloque.match(/SOLUCIÓN:\s*([\s\S]*)/i);
      
      return {
        diagnostico: diagMatch ? diagMatch[1].trim() : '',
        solucion: solMatch ? solMatch[1].trim() : ''
      };
    },

    redondear(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },

    seleccionarCachéas() {
      this.tipoVenta = 'CREDITO';
      this.tipoCredito = 'cacheas';
      this.recalcularTotalCacheas();
      this.calcularCuotas();
    },

    recalcularTotalCacheas() {
      const itemsSum = this.todosLosItems.reduce((sum, it) => sum + (parseFloat(((it.precio_total || it.precio || 0) * 1.17)) || 0), 0);
      const diagSum = (parseFloat((this.orden?.montoDiagnostico || 0) * 1.17) || 0);
      this.total_con_recargo_cacheas = this.redondear(itemsSum + diagSum);
    },

    ajustarItemsDesdeTotalCacheas() {
      if (!this.total_con_recargo_cacheas || this.total_con_recargo_cacheas <= 0) this.total_con_recargo_cacheas = 0;
      this.calcularCuotas();
    },

    getGreeting() {
      const hour = new Date().getHours();
      if (hour < 12) return "Buenos días";
      if (hour < 18) return "Buenas tardes";
      return "Buenas noches";
    },
    enviarMensajeWhatsapp() {
      const message = this.whatsappFullMessage;
      
      let phone = this.clienteFull?.telefono || '';
      if (!phone) {
        this.toast.error("El cliente no tiene un número de teléfono registrado.");
        return;
      }
      
      let cleanPhone = phone.replace(/\D/g, '');
      
      if (cleanPhone.length === 10 && !cleanPhone.startsWith('58')) {
        cleanPhone = '58' + cleanPhone;
      } else if (cleanPhone.length === 11 && cleanPhone.startsWith('0')) {
        cleanPhone = '58' + cleanPhone.substring(1);
      } else if (cleanPhone.length === 11 && !cleanPhone.startsWith('58')) {
      } else if (cleanPhone.length < 10) {
        this.toast.warning("El número de teléfono parece estar incompleto.");
      }
      
      const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');
      this.cerrarModalWhatsapp();
    },
    cerrarModalWhatsapp() {
      this.showWhatsappModal = false;
      this.$router.push('/recepcion-equipo-list');
    }
  }
};
</script>

<style scoped>
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
@keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
.animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }
.animate-slideUp { animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
</style>